<template>
    <div>
        <v-card >
            <v-card-title class="blue-grey white--text">
                <v-row>
                    <v-col cols="6" md="6">EXPRESS</v-col>
                    <v-col cols="6" md="6" class="text-end">
                        <h5 class="text-caption white--text">Bodega: {{ txtSucursal }}</h5>
                        <h5 class="text-caption white--text">Dirección Tributaria: {{ txtOffice }}</h5>
                    </v-col>
                    <!-- <v-col cols="6" md="6">
                        <v-row class="mt-0 mr-2" justify="end">
                            <span class="text-caption"><v-chip color="white"><strong class="text-body-2">{{txtSucursal}}</strong></v-chip></span>
                        </v-row>
                    </v-col> -->
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row class="mt-1">
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="6" md="4">
                                <v-text-field style="width:130px" id="barr"  label="Codigo Barra"
                                  @change="captureBarra_v2(barra)" class='text-caption'
                                  @keypress="onlyNumber" v-model="barra" dense outlined>
                                </v-text-field>
                            </v-col>
                            <v-col cols="6" md="8" class="text-center">
                                <v-row>
                                    <v-col cols="12" md="6">
                                        <v-badge bordered overlap color="error" :content="pendientecuenta">
                                        <v-btn @click="pendiente=true" small color="indigo" dark rounded>
                                            <v-icon small>find_replace</v-icon>
                                            <span class="text-btn">Pendiente</span>
                                        </v-btn>                                
                                        </v-badge>
                                    </v-col>
                                    <v-col cols="12" md="6">
                                        <v-btn @click="inventa=true" small color="indigo" dark rounded>
                                            <v-icon small>find_replace</v-icon>
                                            <span class="text-btn">Productos</span>
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n7">
                            <v-col cols="12" md="12">
                                <v-data-table height="220" :headers="headers" :items="items" :page.sync="page" :items-per-page="itemsPerPage" hide-default-footer class="elevation-1 text-size col-color" @page-count="pageCount = $event">
                                    <template v-slot:item.cantidad="{ item }">
                                        <v-edit-dialog @save="save(item,editCantidad)" @cancel="cancel()" @close="close()" @open="open()">
                                            <v-icon small class="ml-1 blue--text">edit</v-icon>
                                            <span class="ml-1">{{item.cantidad}}</span>
                                            <template v-slot:input>
                                                <div class="mt-4 text-h6">Cantidad</div>
                                                <v-text-field v-if="item.medida!='UN'" @keypress="onlyDecimal" v-model="editCantidad" single-line></v-text-field>
                                                <v-text-field v-else @keypress="onlyNumber" v-model="editCantidad" single-line></v-text-field>
                                            </template>
                                        </v-edit-dialog>
                                    </template>
                                    <template v-slot:item.menor="{ item }">
                                        <v-icon class="ml-1 red--text" @click="menos(item)">arrow_drop_down</v-icon>
                                    </template>
                                    <template v-slot:item.convierte="{ item }">
                                        <v-icon small v-if="item.medida!='UN'" @click="convierteFila(item)" color="success">track_changes</v-icon>
                                        <span v-else>-</span>
                                    </template>
                                    <template v-slot:item.accion="{ item }">
                                        <v-icon small @click="deleteFila(item)" color="red">delete</v-icon>
                                    </template>
                                    <template v-slot:item.precio="{ item }">
                                        <div v-if="habilita_precio==1">
                                            <v-edit-dialog @save="changePrice(item,editPrecio)" @cancel="cancel()" @close="close()" @open="open()">
                                                <v-icon small class="ml-1 blue--text">edit</v-icon>
                                                <span class="ml-1">{{item.precio}}</span>
                                                <template v-slot:input>
                                                    <div class="mt-4 text-h6">Precio</div>
                                                    <v-text-field @keypress="onlyNumber" v-model="editPrecio" single-line></v-text-field>
                                                </template>
                                            </v-edit-dialog>
                                        </div>
                                        <div v-else>
                                            <span class="ml-1">{{item.precio}}</span>
                                        </div>
                                    </template>
                                    <template v-slot:item.descuento="{ item }">
                                        <div v-if="habilita_precio==1">
                                            <v-icon @click = "open_discount(item)" small class="ml-1 blue--text">edit</v-icon>
                                            <span class="ml-1">{{new Intl.NumberFormat("de-DE").format(parseFloat(item.descuento))}}</span>
                                        </div>
                                        <div v-else>
                                            <span class="ml-1">{{ item.descuento }}</span>
                                        </div>
                                    </template>

                                </v-data-table>
                                <v-pagination v-model="page" :length="pageCount" :total-visible="5"></v-pagination>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="4">
                        <v-row>
                            <v-col cols="12" md="12">
                                <div v-if="ntipoDte==22">
                                    <v-row>
                                        <v-col cols="6" md="6">
                                            <v-btn block color="teal" dark>Boleta</v-btn>
                                        </v-col>
                                        <v-col cols="6" md="6">
                                            <v-btn @click="cualDte(5)" block color="grey" outlined>Factura</v-btn>                                
                                        </v-col>
                                    </v-row>
                                </div>
                                <div v-if="ntipoDte==5">
                                    <v-row>
                                        <v-col cols="6" md="6">
                                            <v-btn @click="cualDte(22)" block color="grey" outlined>Boleta</v-btn>                                
                                        </v-col>
                                        <v-col cols="6" md="6">
                                            <v-btn @click="cualDte(5)" block color="teal" dark>Factura</v-btn>
                                        </v-col>
                                    </v-row>
                                </div>
                            </v-col>
                        </v-row>
                        <v-row>
                            <v-col cols="12" md="12" >
                                <v-text-field class='text-caption' v-model="clienteExpress" label="Cliente" dense outlined filled disabled hint="rutExpress"></v-text-field>
                                <div class="mt-n7 ml-3"><span class="text-caption grey--text">{{rutExpress}}</span></div>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n5">
                            <v-col cols="12" md="12" >
                                <v-text-field class='text-caption' v-model="envio" label="Envio Digital" dense outlined></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n7">
                            <v-col cols="12" md="5" >
                                <v-menu v-model="menu1" :close-on-content-click="false" :nudge-right="10" transition="scale-transition" offset-y min-width="auto">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-text-field class="text-caption" v-model="vencimiento" label="Ven." prepend-icon="event" readonly v-bind="attrs" v-on="on" dense outlined></v-text-field>
                                    </template>
                                    <v-date-picker v-model="vencimiento" @input="menu1 = false"></v-date-picker>
                                </v-menu>
                            </v-col>
                            <v-col cols="12" md="7" >
                                <v-select class='text-caption' v-model="pago" :items="itemPAGO" label="Forma Pago" item-text="forma" item-value="id" outlined dense></v-select>
                            </v-col>
                        </v-row>
                        <v-row class="mt-n10">
                            <v-col cols="12" md="6" class="mt-2">
                                <v-sheet v-if="habilita_canje=='si'" style="border: 1px solid lightgray" rounded="xl">
                                    <v-container>
                                        <v-btn @click="d_Canje=true" x-small rounded dark block>CANJEAR PUNTOS</v-btn>
                                        <h4 class="mt-2">CODIGO: {{ numero_canje }}</h4>
                                    </v-container>
                                </v-sheet>
                            </v-col>
                            <v-col cols="12" md="6" class="mt-2 text-end">
                                <a v-if="voucherHTML!=''" target="_blank" :href="voucherHTML">
                                    <v-btn x-small rounded color="info" dark block>VOUCHER DE DESCUENTO</v-btn>
                                </a>
                                <a v-else href="javascript:void(0)">
                                    <v-btn x-small rounded color="grey" dark block>VOUCHER DE DESCUENTO</v-btn>
                                </a>
                                <div v-if="habilita_canje=='si'" class="mt-5">
                                    <v-btn v-if="btnPrt===true" @click="d_Puntos=true" x-small rounded dark block>ACTIVAR PUNTO CANJE</v-btn>
                                    <v-btn v-else x-small rounded color="grey" dark block>ACUMULAR PUNTOS</v-btn>                                
                                </div>
                            </v-col>
                        </v-row>
                    </v-col>
                </v-row>
            </v-card-text>
            <v-card-actions class="mt-n5">
                <v-row>
                    <v-col cols="12" md="8">
                        <v-row>
                            <v-col cols="12" md="4">
                                <v-card color="blue-grey" dark>
                                    <v-card-title>
                                        <h6>NETO</h6>
                                        <v-spacer></v-spacer>
                                        <h5>$ {{new Intl.NumberFormat("de-DE").format(parseFloat(mto_totalNeto))}}</h5>
                                    </v-card-title>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-card color="blue-grey" dark>
                                    <v-card-title>
                                        <h6>IVA ({{impuesto}}%)</h6>
                                        <v-spacer></v-spacer>
                                        <h5>$ {{new Intl.NumberFormat("de-DE").format(parseFloat(mto_totalIva))}}</h5>
                                    </v-card-title>
                                </v-card>
                            </v-col>
                            <v-col cols="12" md="4">
                                <v-card color="blue-grey" dark>
                                    <v-card-title>
                                        <!-- <h6>TOTAL (<span style="font-size:7.5pt">Ajuste ${{totalAjuste}}</span>)</h6> -->
                                        <h6>TOTAL</h6>
                                        <v-spacer></v-spacer>
                                        <h5>$ {{new Intl.NumberFormat("de-DE").format(parseInt(mto_totalVenta).toFixed(2))}}</h5>
                                    </v-card-title>
                                </v-card>
                            </v-col>
                        </v-row>
                    </v-col>
                    <v-col cols="12" md="1" class="mt-7">
                        <v-btn @click="add_pendiente()" small color="teal" dark rounded><v-icon small>add_circle_outline</v-icon><span class='text-btn'>Pendiente</span></v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="mt-7 text-center">
                        <v-btn @click="nuevaVenta()" small color="teal" dark rounded>&nbsp;&nbsp;&nbsp;<v-icon small>add_circle</v-icon><span class='text-btn'>Nuevo</span>&nbsp;&nbsp;&nbsp;</v-btn>
                        <v-btn class="ml-5" v-if="btnGrabar===true" @click="enviarDTE()" small color="teal" dark rounded>&nbsp;&nbsp;&nbsp;<v-icon small>save</v-icon><span class='text-btn'>Enviar DTE</span>&nbsp;&nbsp;&nbsp;</v-btn>
                        <v-btn class="ml-5" v-else small color="grey" dark rounded>&nbsp;&nbsp;&nbsp;<v-icon small>save</v-icon><span class='text-btn'>Enviar DTE</span>&nbsp;&nbsp;&nbsp;</v-btn>
                        <v-btn v-if="sigla=='INV'" icon>
                            <a class="ml-10" v-if="btnPrt===true" target="_blank" :href="html"><v-icon color="teal">print</v-icon></a>
                            <a class="ml-10" v-else href="javascript:void(0)"><v-icon class="grey--text">print</v-icon></a>
                        </v-btn>    
                        <v-btn v-if="sigla=='NDV'" icon>
                            <v-icon class="ml-10" v-if="btnPrt===true" @click="imprimirPDF()" color="teal" large>print</v-icon>
                            <v-icon class="ml-10" v-else color="grey" large>print</v-icon>
                        </v-btn>
                    </v-col>
                </v-row>
            </v-card-actions>
        </v-card>
        <!-- dialog inventa --> 
        <v-dialog v-model="inventa" transition="dialog-bottom-transition" max-width="50%" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="6" md="3">
                        <v-btn @click="inventa=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                    </v-col>
                    <v-col cols="6" md="5">
                        <!-- <h6>Bodega : {{txtBodega}}</h6>                 -->
                    </v-col>
                    <v-col cols="12" md="4" class="text-right">
                        <v-text-field class='ml-5 mr-2 text-caption' v-model="inventasearch" label="Buscar Producto" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleProductos" dense dark :search="inventasearch" :headers="inventatitulo" :items="inventalista" :page.sync="inventapage" :items-per-page="inventaitemsPerPage"  @page-count="inventapageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="inventapage" :length="inventapageCount" :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>
        <!-- dialog clientes --> 
        <v-dialog v-model="clientes" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="clientes=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                <v-spacer>
                    <div class="float-right">
                    <v-text-field class='ml-5 mr-2 text-caption' v-model="clientesearch" label="Buscar Cliente" dense required></v-text-field>
                    </div>
                </v-spacer>
            </v-card-title>
            <v-card-text>
                <v-data-table @click:row="handleClientes" dense dark :search="clientesearch" :headers="clientetitulo" :items="clientelista" :page.sync="clientepage" :items-per-page="clienteitemsPerPage"  @page-count="clientepageCount = $event" hide-default-footer class="elevation-1 text-size">
                </v-data-table>
                <v-pagination v-model="clientepage" :length="clientepageCount" :total-visible="5"></v-pagination>
            </v-card-text>
        </v-card>
        </v-dialog>
        <!-- dialog convierte --> 
        <v-dialog v-model="convierte" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-btn class="mt-2 ml-2" @click="convierte=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
            <v-card-title>
                Convertir Unidad de Medida ( 1 x ${{valorKG}} )
            </v-card-title>
            <v-card-text>
                <v-container>
                <v-row>
                    <v-col cols="12" md="3" class="text-center">
                        <v-text-field @keypress="onlyDecimal" v-model="cantidadKG" label="Cantidad" dense outlined :filled="filConvierte" :disabled="disConvierte"></v-text-field>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <v-btn @click="cantidad_precio()" dark color="indigo"><v-icon>fast_forward</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <v-btn @click="precio_cantidad()" dark color="indigo"><v-icon>fast_rewind</v-icon></v-btn>
                    </v-col>
                    <v-col cols="12" md="3" class="text-center">
                        <v-text-field @keypress="onlyNumber" v-model="precioKG" label="Precio" dense outlined :filled="filConvierte" :disabled="disConvierte"></v-text-field>                        
                    </v-col>
                </v-row>
                </v-container>
            </v-card-text>
            <v-card-actions class="mt-n10">
                <v-btn @click="no_aplica()" color="success" small>LIMPIAR</v-btn>
                <v-spacer></v-spacer>
                <v-btn v-if="btnAplica==true" @click="si_aplica()" color="success" small>APLICAR</v-btn>
                <v-btn v-else color="grey" small>APLICAR</v-btn>
            </v-card-actions>
        </v-card>
        </v-dialog>
        <!-- dialog pendiente --> 
        <v-dialog v-model="pendiente" transition="dialog-bottom-transition" max-width="600" persistent>
        <v-card>
            <v-card-title>
                <v-row>
                    <v-col cols="6" md="3">
                        <v-btn @click="pendiente=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                    </v-col>
                    <v-col cols="6" md="5">
                        <!-- <h6>Bodega : {{txtBodega}}</h6>                 -->
                    </v-col>
                    <v-col cols="12" md="4" class="text-right">
                        <v-text-field class='ml-5 mr-2 text-caption' v-model="pendientesearch" label="Buscar" dense required></v-text-field>
                    </v-col>
                </v-row>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12" md="12">
                        <v-data-table @click:row="handlePendiente" dense dark :search="pendientesearch" :headers="pendientetitulo" :items="pendientelista" :page.sync="pendientepage" :items-per-page="pendienteitemsPerPage"  @page-count="pendientepageCount = $event" hide-default-footer class="elevation-1 text-size">
                        </v-data-table>
                    </v-col>
                    <v-col cols="12" md="8">
                        <v-pagination v-model="pendientepage" :length="pendientepageCount" :total-visible="5"></v-pagination>
                    </v-col>
                    <v-col cols="12" md="4" class="mt-2">
                        <span class="text-caption">Eliminar Pendientes</span>
                        <v-btn text icon class="ml-2"><v-icon @click="deletePendiente()" color="red">delete</v-icon></v-btn>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        </v-dialog>
        <!-- dialogo descuento -->
        <v-dialog v-model="d_descuento" transition="dialog-bottom-transition" max-width="550" persistent>
        <v-card>
            <v-card-title>
                <v-btn @click="d_descuento=false" color="red" small dark><v-icon small>close</v-icon></v-btn>
                <h5 class="ml-5">Descuento Unitario</h5>
            </v-card-title>
            <v-card-text>
                <v-container>
                    <v-row>
                        <v-col cols="12" md="4">
                            <v-text-field @keypress="onlyNumber" v-model="myOriginal" label="Precio Origen ($)" dense outlined filled disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field @keypress="onlyNumber" v-model="myDiscount" label="Descuento ($)" dense outlined clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-text-field @keypress="onlyNumber" v-model="myPrecio" label="Precio Venta ($)" dense outlined filled disabled></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12" class="mt-n5">
                            <v-text-field v-model="myConcepto" maxlength="25" label="Concepto Descuento" dense outlined></v-text-field>
                        </v-col>
                        <v-col cols="12" md="12">
                            <v-btn @click="aplicar_discount()" color="teal" small block rounded dark>APLICAR</v-btn>
                        </v-col>
                    </v-row>
                    <!-- <v-sheet rounded="xl" class="mt-1" style="border:1px solid lightgrey">
                        <h3 class="mt-5 mr-5 mb-5 ml-5">Al aplicar descuentos, los totales pueden mostrar diferencia en decimales. Recuerde aplicar redondeo</h3>
                    </v-sheet> -->
                </v-container>
            </v-card-text>
        </v-card>
        </v-dialog>

        <v-dialog v-model="d_mensualidad" transition="dialog-bottom-transition" max-width="400" persistent>
            <v-card rounded="xl">
                <v-card-title>
                    SERVICIO SUSPENDIDO
                    <v-spacer></v-spacer>
                    <v-icon @click="goLogin()">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" class="text-center">
                            <span class="text-body-2">
                                Tú servicio se encuentra suspendido.<br>
                                comunicate con soporte
                            </span>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
         </v-dialog>        

        <v-dialog v-model="d_Puntos" transition="dialog-bottom-transition" max-width="400" persistent>
            <v-card rounded="xl">
                <v-card-title>
                        ACUMULAR PUNTOS
                    <v-spacer></v-spacer>
                    <v-icon @click="d_Puntos=false" color="red">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="3"></v-col>
                        <v-col cols="12" md="6">
                            <h5 class="font-italic">Rut sin puntos y con guion</h5>
                            <v-text-field v-model="cliente_PuntoCanje" maxlength="10" large outlined clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" md="3"></v-col>
                    </v-row>
                    <v-row class="mt-n8">
                        <v-col cols="12" md="6">
                            <v-text-field v-model="boleta_PuntoCanje" label='N° Boleta' dense outlined filled readonly rounded></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-text-field v-model="monto_PuntoCanje" label="Monto" dense outlined filled readonly rounded></v-text-field>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n8">
                        <v-col cols="12" md="12">
                            <v-btn v-if="btn_puntos!=true" @click='add_puntos()' dark block rounded>Ingresar</v-btn>
                            <v-btn v-else dark color="grey" block rounded>Ingresar</v-btn>
                        </v-col>
                    </v-row>
                </v-card-text>
            </v-card>
         </v-dialog>
                 
        <v-dialog v-model="d_Canje" transition="dialog-bottom-transition" max-width="400" persistent>
            <v-card rounded="xl">
                <v-card-title>
                        CANJEAR PUNTOS
                    <v-spacer></v-spacer>
                    <v-icon @click="d_Canje=false" color="red">close</v-icon>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col cols="12" md="6">
                            <h5 class="font-italic">Rut sin puntos y con guion</h5>
                            <v-text-field v-model="cliente_PuntoCanje" maxlength="10" large outlined clearable></v-text-field>
                        </v-col>
                        <v-col cols="12" md="6">
                            <v-btn @click="search_canjes()" class="mt-5" fab dark><v-icon>search</v-icon></v-btn>
                        </v-col>
                    </v-row>
                    <v-row class="mt-n8">
                        <v-col cols="12" md="12">
                            <v-simple-table fixed-header dense height="200">
                                <thead>
                                    <tr>
                                        <th class="text-left">
                                            Codigo
                                        </th>
                                        <th class="text-end">
                                            Monto
                                        </th>
                                        <th class="text-end">
                                            ......
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="item in myPuntoCanje" :key="item.id">
                                        <td class="text-left"><span class="text-h6">{{item.canje}}</span></td>
                                        <td class="text-end"><span class="text-h6">$ {{new Intl.NumberFormat("de-DE").format(parseFloat(item.monto))}}</span></td>
                                        <td class="text-end">
                                            <v-icon @click="ck_canje(item)" v-if="item.check!=true" color="red">check_box_outline_blank</v-icon>
                                            <v-icon @click="ck_canje(item)" v-else color="success">check_box</v-icon>
                                        </td>
                                    </tr>
                                </tbody>
                            </v-simple-table>                        
                        </v-col>
                    </v-row>
                    <!-- <v-row>
                        <v-col cols="12" md="12">
                            <v-btn @click='add_canje()' dark block rounded>Canjear</v-btn>
                        </v-col>
                    </v-row> -->
                </v-card-text>
            </v-card>
         </v-dialog>        

         <snack :Msg="Msg" :color="color" :msgbox="msgbox"/>
        <dialogo :loading="loading"  />        
    </div>
</template>
<style scoped>
.text-size >>> td {
    font-size: 9pt !important;
    height: 25px !important;
    /*background-color: lightyellow;*/ 
}
.col-color >>> th {
    background-color: lightgrey;
}
</style>
<script>
import snack from '@/components/snack.vue';
import dialogo from '@/components/dialogo.vue';
import { jsPDF } from "jspdf";
import PDF417 from '../pdf417-min';
import axios from 'axios';
//import JsBarcode from 'jsbarcode'
export default {
    name:'Venta', 
    components:{dialogo, snack},
    props: ['usu','contrato'],   
    data(){
        return{
            loading:false,
            msgbox:false,
            color:'',
            Msg:'',
            sigla:'',
            clienteExpress:'Boleta DTE',
            rutExpress:'1-9',
            ntipoDte:22,  // (22) Boleta ; (5) Factura
            dialogoPago:false,
            orden:'',
            headers: [
                { text: 'Sku', align: 'start', sortable: true, value: 'sku', width:'10%' },
                { text: 'Producto', align: 'start', sortable: false, value: 'producto', width:'35%' },
                { text: 'Medida', align: 'center', sortable: false, value: 'medida', width:'3%' },
                { text: '', align: 'end', sortable: false, value: 'convierte', width:'2%' },
                { text: 'Precio', align: 'end', sortable: false, value: 'precio', width:'15%' },
                { text: 'Descuento', align: 'end', sortable: false, value: 'descuento', width:'15%' },
                { text: 'Cantidad', align: 'end', sortable: false, value: 'cantidad', width:'15%' },
                { text: '', align: 'start', sortable: false, value: 'menor', width:'2%' },
                { text: '', align: 'center', sortable: false, value: 'accion', width:'3%' },
            ],
            items: [],
            page: 1,
            pageCount: 0,
            itemsPerPage: 5,
            itemDTE:[
                {id:'22',doc:'Boleta'},
                {id:'5',doc:'Factura'},
            ],
            inventa:false,
            inventasearch:'',
            inventatitulo:[
                { text: 'Sku', align: 'start', sortable: true, value: 'sku', width:'' },
                { text: 'Cod. Barra', align: 'start', sortable: true, value: 'barraSku' },
                { text: 'Producto', align: 'start', sortable: true, value: 'nameSku' },
                { text: 'Medida', align: 'start', sortable: true, value: 'medida' },
                { text: 'Stock', align: 'start', sortable: true, value: 'vistaStock' },
                //{ text: 'Stock', align: 'start', sortable: true, value: 'stockSku' },
            ],
            inventalista:[],
            inventapage: 1,
            inventapageCount: 0,
            inventaitemsPerPage: 10,
            clientes:false,
            clientesearch:'',
            clientetitulo:[
                { text: 'Rut', align: 'start', sortable: true, value: 'rut' },
                { text: 'Cliente', align: 'start', sortable: true, value: 'nombre' },
                { text: 'Alias', align: 'start', sortable: true, value: 'alias' },
            ],
            clientelista:[],
            clientepage: 1,
            clientepageCount: 0,
            clienteitemsPerPage: 10,

            pendiente:false,
            pendientecuenta:0,
            search_id:0,
            pendientesearch:'',
            pendientetitulo:[
                { text: 'ID', align: 'center', sortable: false, value: 'pen_id', width:'' },
                { text: 'Fecha', align: 'center', sortable: false, value: 'pen_fecha' },
                { text: 'Hora', align: 'center', sortable: false, value: 'pen_hora' },
                { text: 'Total Sku', align: 'center', sortable: false, value: 'pen_total' },
            ],
            pendientelista:[],
            pendientepage: 1,
            pendientepageCount: 0,
            pendienteitemsPerPage: 10,

            totalVenta:0,
            totalNeto:0,
            totalAjuste:0,
            totalIva:0,

            mto_totalVenta:0,
            mto_totalNeto:0,
            mto_totalIva:0,
            mto_totalAjuste:0,

            btnGrabar:true,
            btnPrt:false,
            itemPAGO:[],
            barra:'',
            html:'',

            entidad:'',
            entidad_boleta:'',
            rut:'',
            razon:'',
            direccion:'',
            comuna:'',
            ciudad:'',
            giro:'',
            fecha:'',
            hoy:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            neto:0,
            impuesto:'',
            iva:0,
            total:0,
            dte:'',
            pago:'',
            
            OutID:0,
            descargaCSV:false,
            rutaCSV:'',   
            envio:'',
            nStock:0,
            txtStock:'si',
            nSucursal:0,
            txtSucursal:'',
            menu1:false,
            vencimiento:(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
            vendedor:0,
            nBodega:0,
            txtBodega:'Sin Bodega',
            editCantidad:'',
            idLocal:0,
            editPrecio:'',
            // Convierte
            filaConvierte:[],
            convierte:false,
            valorKG:0,
            upCantidad:0,
            cantidadKG:0,
            precioKG:0,
            filConvierte:false,
            disConvierte:false,
            btnAplica:false,
            //pos80
            pos:false,
            office:1,
            itemsucursal:[],
            txtOffice:'',
            habilita_precio:1,
            tipo_descuento:'%',
            itemDescuento:['%','$'],
            valor_descuento:0,
            discount:0,
            btn_descuento:false,
            d_descuento:false,
            myLine:null,
            myPrecio:0,
            myOriginal:0,
            myDiscount:0,
            myConcepto:'',

            voucherHTML:'',

            myTokenBsale:'',
            myTED:'',
            timbre_PDF:'',
            d_mensualidad:false,
            price:0,

            rut_emisor:'',
            d_Puntos:false,
            d_Canje:false,
            boleta_PuntoCanje:'', //numero de la boleta
            monto_PuntoCanje:'', //monto de la boleta
            emisor_PuntoCanje:'', //rut = rut del emisor
            cliente_PuntoCanje:'', //pk-user = rut cliente
            imagen_PuntoCanje:'', //ruta del Dte.
            myPuntoCanje:[],
            numero_canje:'',
            btn_puntos:false,
            habilita_canje:'no',
            nClicks:0,


            timbre_universal:'data:image/png;base64,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'
        }
    },
    async mounted(){
        this.sigla=this.contrato.substring(0,3).toUpperCase();
        await this.buscaImpuesto();
        await this.focusBarra();
        this.loading=true;
        await this.buscaSucursal();
        await this.buscaLocal();
        await this.newVenta();
        await this.cargaPagos('1-9');
        this.loading=false;
        //JsBarcode("#barcode", "123456");
        await this.search_pendientes();
        await this.search_myRut();
    },
    methods:{
        async validaMensualidad(){
            let result = 'si'
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/token/access/'+this.contrato);
                const datos = response.data;
                if (datos[0].existe=='no'){ 
                    result = 'no'
                }
            } catch (error) {
                console.log(error)
            }
            return result
        },
        async open_discount(line){
            this.myLine = line;
            this.myPrecio = line.valor;
            this.myOriginal = line.original;
            this.myDiscount = line.descuento;
            this.myConcepto = line.concepto;
            this.d_descuento = true;
        },
        async aplicar_discount(){
            if(this.myDiscount!=null && this.myDiscount!=''){
                console.log('myDiscount',this.myDiscount)
                if(parseFloat(this.myDiscount)!=0){
                    this.myPrecio = parseFloat(this.myPrecio) - parseFloat(this.myDiscount);
                    this.savePrecio(this.myLine,this.myPrecio);
                    this.myLine.descuento = parseFloat(this.myDiscount);
                    this.myLine.concepto = this.myConcepto;
                } else {
                    this.myPrecio = this.myLine.original;
                    this.savePrecio(this.myLine,this.myPrecio);
                    this.myDiscount = 0;
                    this.myLine.descuento = this.myDiscount;
                    this.myConcepto = '';
                    this.myLine.concepto = this.myConcepto;
                };
                this.d_descuento = false;
            }
        },
        async buscaSucursal(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/sucursales/'+this.contrato);
            const datos=response.data;
            this.itemsucursal=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    this.itemsucursal.push({"code":element.Oficina,"name":element.Nombre})
                });
            }
        },
        async convierteFila(linea){
            this.filaConvierte=linea
            this.convierte=true;
            this.valorKG=linea.valor;
            this.cantidadKG=1;
            this.precioKG=linea.valor;
            this.filConvierte=false;
            this.disConvierte=false;
            this.btnAplica=false;
        },
        cantidad_precio(){
            if(this.cantidadKG.trim()!=''){
                if(!isNaN(this.cantidadKG)){
                    //aplicamos regla de 3
                    let valor=parseFloat(this.cantidadKG)*parseFloat(this.valorKG);
                    valor=parseInt(valor);
                    this.precioKG=valor;
                    this.upCantidad=this.cantidadKG;
                    this.filConvierte=true;
                    this.disConvierte=true;
                    this.btnAplica=true;
                } else {
                    this.Msg='Cantidad Invalida';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                    newCantidad='';
                };
            }
        },
        precio_cantidad(){
            if(this.precioKG.trim()!=''){
                if(!isNaN(this.precioKG)){
                    //aplicamos regla de 3
                    let valor=parseFloat(this.precioKG)/parseFloat(this.valorKG);
                    this.upCantidad=parseFloat(valor);
                    valor=parseFloat(valor).toFixed(3);
                    this.cantidadKG=valor;
                    this.filConvierte=true;
                    this.disConvierte=true;
                    this.btnAplica=true;
                } else {
                    this.Msg='Cantidad Invalida';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                    newCantidad='';
                };
            }
        },
        no_aplica(){
            this.upCantidad=0;
            this.cantidadKG=1;
            this.precioKG=this.valorKG;
            this.filConvierte=false;
            this.disConvierte=false;
            this.btnAplica=false;
        },
        si_aplica(){
            if(!isNaN(this.upCantidad)){
                this.save(this.filaConvierte,parseFloat(this.upCantidad));
                this.convierte=false
            } else {
                 this.no_aplica()
            }
        },
        async buscaImpuesto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/impuesto/'+this.contrato);
            const datos=response.data;
            this.impuesto=0;
            if (datos[0].existe=='si'){
                this.impuesto=datos[0].Iva
            }
        },
        async buscaLocal(){
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+this.contrato+'/'+this.usu);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.idLocal=datos[0].Bodega;
                    this.nSucursal=this.idLocal;
                    this.vendedor=datos[0].ID;
                    this.nBodega=datos[0].Bodega;
                    this.office=datos[0].Sucursal;
                    this.price=datos[0].Precio;
                    this.habilita_precio=datos[0].Permiso_8_3;
                    this.habilita_canje=datos[0].PuntoCanje;
                    const sucu=await this.buscarSucursal_v2();
                    this.txtOffice='';
                    const filter = this.itemsucursal.filter(res => parseInt(res.code) == parseInt(this.office));
                    if(filter.length!=0){ this.txtOffice = filter[0].name};
                    if(sucu!=''){
                        this.txtSucursal=sucu;
                        this.txtBodega=sucu
                    } else {
                        this.txtSucursal=this.nSucursal;
                        this.txtBodega=this.nSucursal
                    }
                }
            } catch (error) {
                console.log(error)
            }
        },
        async buscarSucursal_v2(){
            let res = '';
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        if(element.ID==this.nSucursal){
                            res = element.Nombre
                        };
                    });
                }                
            } catch (error) {
                console.log(error)
            };
            return res
        },
        showSnack(){
            setTimeout(()=>{this.msgbox=false},3000)
        },
        cualDte(nDte){
            if(nDte==22){
                this.clienteExpress='Boleta DTE';
                this.rutExpress='1-9';
                this.entidad=this.entidad_boleta;
                this.envio='';
                this.ntipoDte=22;
                const timestamp = Date.now();
                this.orden=this.vendedor+''+timestamp.toString();
                //console.log(this.orden);
                this.cargaPagos(this.rutExpress);
            };
            if(nDte==5){
                this.clienteExpress='';
                this.rutExpress='.';
                this.envio='';
                this.entidad='';
                this.ntipoDte=5;
                this.clientes=true;
                const timestamp = Date.now();
                this.orden=this.vendedor+''+timestamp;
                //console.log(this.orden);
            };

        },
        async buscarProducto(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/stock/datatable/v3/'+this.contrato);
            const datos=response.data;
            // const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/productos/'+this.contrato);
            // const datos=response.data;
            this.inventalista=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    let precio_lista = 0;
                    if(this.price=='Detalle'){ precio_lista = element.PrecioLocal };
                    if(this.price=='Mayor'){ precio_lista = element.PrecioMayor };
                    if(this.price=='Oferta'){ precio_lista = element.PrecioOferta };
                    if(parseFloat(element.Total)>0 && parseFloat(element.numBodega)==parseFloat(this.nBodega)){
                        this.inventalista.push({
                            sku:element.Sku,
                            barraSku:element.Barra,
                            nameSku:element.Nombre,
                            precioSku: precio_lista,
                            vistaStock:new Intl.NumberFormat("de-DE").format(parseFloat(element.Total).toFixed(3)),
                            stockSku:element.Total,
                            medida:element.Medida
                        });                    
                    }
                });
            }
        },
        handleProductos(fila) {
            if(this.btn_descuento!=true){
                //buscamos sku en la lista
                console.log(fila)
                this.barra='';
                let esta='no';
                let imp = 0;
                if(parseFloat(this.impuesto)!=0){ imp = 1 + (this.impuesto/100) };
                let precio_item=0;
                if(this.items.length!=0){
                    this.items.forEach(element => {
                        if (element.sku==fila.sku){
                            esta='si';
                            element.valorCantidad=parseFloat(element.valorCantidad)+1;
                            element.cantidad=new Intl.NumberFormat("de-DE").format(parseFloat(element.valorCantidad));
                            precio_item=parseFloat(element.valor);
                            // element.valor=parseFloat(element.valor)+parseFloat(fila.precioSku);
                            // element.precio=new Intl.NumberFormat("de-DE").format(parseFloat(element.valor));
                        };
                    });
                };
                if(esta=='no'){
                    let unidad = fila.precioSku;
                    if(parseFloat(imp)!=0){ unidad = fila.precioSku/imp };
                    this.items.push({
                        sku:fila.sku,
                        producto:fila.nameSku,
                        precio:new Intl.NumberFormat("de-DE").format(parseFloat(fila.precioSku)),
                        valor:parseFloat(fila.precioSku),
                        unidad:unidad,
                        cantidad:1,
                        valorCantidad:1,
                        medida:fila.medida,
                        bodega:this.nBodega,
                        original: fila.precioSku,
                        descuento:0,
                        concepto:'',
                    });
                    precio_item=parseFloat(fila.precioSku);
                };
                // this.totalNeto=this.totalNeto+parseFloat(fila.precioSku);
                // this.totalIva=Math.round(((parseFloat(this.totalNeto)*19)/100),0);
                // this.totalVenta=parseFloat(this.totalNeto)+parseFloat(this.totalIva);
                this.totalVenta = parseFloat(this.totalVenta) + parseFloat(precio_item);
                this.mto_totalVenta = this.totalVenta;

                this.totalNeto = this.totalVenta;
                if(parseFloat(imp)!=0){ this.totalNeto = this.totalVenta / imp };

                //this.totalNeto=parseFloat(this.totalNeto).toFixed(2);
                this.mto_totalNeto=parseFloat(this.totalNeto).toFixed(2);

                this.totalIva=(this.totalNeto*this.impuesto)/100;
                //this.totalIva=parseFloat(this.totalIva).toFixed(2);
                this.mto_totalIva=parseFloat(this.totalIva).toFixed(2);

                // ajuste no aplica para esta app
                this.totalAjuste=this.totalVenta-(this.totalNeto+this.totalIva);
                this.totalAjuste=0;

                if(parseFloat(this.totalNeto)<=0 || parseFloat(this.totalVenta)<=0){
                    this.totalNeto=0;
                    this.totalIva=0;
                    this.totalVenta=0;
                    this.mto_totalNeto=0;
                    this.mto_totalIva=0;
                    this.mto_totalVenta=0;
                }
                this.inventa=false;
            } else {
                this.Msg='Descuento aplicado a la venta, imposible agregar productos'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async buscaCliente(){
            const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/lista/clientes/'+this.contrato);
            const datos=response.data;
            this.clientelista=[];
            if (datos[0].existe=='si'){
                datos.forEach(element => {
                    if(element.Rut==this.rutExpress){ 
                        this.entidad_boleta=element.ID;
                        this.entidad=this.entidad_boleta; 
                    };
                    this.clientelista.push({
                        entidad:element.ID,
                        nombre:element.Nombre,
                        rut:element.Rut,
                        email:element.Email,
                        direccion:element.Direccion,
                        comuna:element.Comuna,
                        ciudad:element.Ciudad,
                        giro:element.Observacion,
                        preciocli:element.Precio,
                        alias:element.Alias
                    })        
                });
            }
        },
        handleClientes(fila) {
            this.clienteExpress=fila.nombre;
            this.rutExpress=fila.rut;
            this.envio=fila.email;
            this.entidad=fila.entidad;
            this.rut=fila.rut;
            this.razon=fila.nombre;
            this.direccion=fila.direccion;
            this.comuna=fila.comuna;
            this.ciudad=fila.ciudad;
            this.giro=fila.giro;
            this.clientes=false;
            this.cargaPagos(this.rutExpress);
            if(fila.preciocli!='Precio Detalle'){
                this.Msg='Cliente con precio especial, realice la venta por cotización'
                this.msgbox=true;
                this.color='warning';
                this.showSnack();
            }
        },
        // async buscarSucursal(){
        //     const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/usuarios/'+this.contrato+'/'+this.usu);
        //     const datos=response.data;
        //     if (datos[0].existe=='si'){
        //         if (datos[0].Sucursal!=0){
        //             this.nSucursal=datos[0].Sucursal;
        //             this.vendedor=datos[0].ID;
        //             this.nBodega=datos[0].Bodega;
        //             //buscar nombre de la bodega
        //             const response0 = await axios.get(process.env.VUE_APP_URL + '/api/inv/bodegas/'+this.contrato);
        //             const datos0=response0.data;
        //             if (datos0[0].existe=='si'){
        //                 datos0.forEach(element => {
        //                     if(element.ID==this.nBodega){
        //                         this.txtBodega=element.Nombre                            
        //                     }
        //                 });
        //             };
        //             //buscar nombre de la sucursal
        //             const response1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/sucursales/'+this.contrato);
        //             const datos1=response1.data;
        //             if (datos1[0].existe=='si'){
        //                 datos1.forEach(element => {
        //                     if(element.ID==this.nSucursal){
        //                         this.txtSucursal=element.Nombre                            
        //                     }
        //                 });
        //             } else {  
        //                 this.txtSucursal='Sin Sucursal';
        //                 this.nSucursal=0;
        //             }
        //         } else {
        //             this.txtSucursal='Sin Sucursal';
        //             this.nSucursal=0;
        //         }
        //     } else { 
        //         this.txtSucursal='Sin Sucursal';
        //         this.nSucursal=0;
        //     }
        // },
        async cargaPagos(xRut){
            try {
                var auth='NO';
                const res = await axios.get(process.env.VUE_APP_URL + '/api/inv/clientes/'+this.contrato+'/'+ xRut);
                const dat=res.data;
                if (dat[0].existe=='si'){ auth=dat[0].Credito };            
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/forma/pago/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    this.itemPAGO=[];
                    datos.forEach(element => {
                        if(element.CodigoBsale=='4'){
                            if(auth=='SI'){
                                this.itemPAGO.push({
                                    'id':element.CodigoBsale,
                                    'forma':element.Descripcion
                                })
                            }
                        } else {
                            this.itemPAGO.push({
                                'id':element.CodigoBsale,
                                'forma':element.Descripcion
                            })
                        }
                    });
                }                
            } catch (error) {
                console.log(error)
            }
            // const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/forma/pago/'+this.contrato);
            // const datos=response.data;
            // if (datos[0].existe=='si'){
            //     this.itemPAGO=[];
            //     datos.forEach(element => {
            //         this.itemPAGO.push({
            //             'id':element.CodigoBsale,
            //             'forma':element.Descripcion
            //         })
            //     });
            // }
        },
        captureBarra_v2(codBarra){
            if(this.btn_descuento!=true){
                if(this.barra.trim()!=''){
                    let resultado=[];
                    if(!isNaN(this.barra)){ // es numero
                        resultado = this.inventalista.filter( datos => parseInt(datos.barraSku) == parseInt(codBarra) );
                    } else { // no es numero
                        resultado = this.inventalista.filter( datos => datos.barraSku == codBarra );
                    };
                    console.log('barra',resultado)
                    if(resultado.length!=0){
                        if(resultado.length>1){
                            this.inventasearch=codBarra;
                            this.inventa=true;
                        } else {
                            const dataBarra = resultado[0];
                            this.handleProductos(dataBarra);
                            this.focusBarra();
                        }
                    } else {
                        //console.log('Producto no Existe');
                        this.Msg='Producto no Existe'
                        this.msgbox=true;
                        this.color='red';
                        this.showSnack();
                        this.focusBarra();
                    };
                };
            } else {
                this.Msg='Descuento aplicado a la venta, imposible agregar productos'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
                this.focusBarra();
            }
            //document.getElementById("barr").dispatchEvent(new KeyboardEvent("keydown", {keyCode: 13}))
        },
        captureBarra(codBarra){
            if(this.barra.trim()!=''){
                const resultado = this.inventalista.find( datos => datos.barraSku == codBarra );
                if(resultado){
                    this.handleProductos(resultado);
                } else {
                    //console.log('Producto no Existe');
                    this.Msg='Producto no Existe'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                };
            };            
            this.focusBarra();
            //document.getElementById("barr").dispatchEvent(new KeyboardEvent("keydown", {keyCode: 13}))
        },
        focusBarra(){
            var elemento = document.getElementById("barr");
            elemento.focus();
            this.barra=''
            //elemento.blur();
        },
        onlyNumber ($event) {
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57)) { // && keyCode !== 46 is dot
                $event.preventDefault();
                this.captureBarra_v2(this.barra);
            }
        },
        onlyDecimal ($event) {
         //console.log($event.keyCode); //keyCodes value
            let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
            if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // && keyCode !== 46 is dot
                $event.preventDefault();
            }
        },
        async nuevaVenta(){
            //console.log(this.items);
            this.loading=true;
            await this.newVenta();
            this.loading=false;
        },
        async newVenta(){
            this.btnGrabar=true;
            this.btnPrt=false;
            this.hoy=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.vencimiento=(new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10);
            this.pago='';
            this.rut='';
            this.entidad='';
            this.razon='';
            this.direccion='';
            this.comuna='';
            this.ciudad='';
            this.giro='';
            this.totalNeto=0;
            this.totalAjuste=0;
            this.totalIva=0;
            this.totalVenta=0;
            this.mto_totalNeto=0;
            this.mto_totalAjuste=0;
            this.mto_totalIva=0;
            this.mto_totalVenta=0;
            this.items=[];
            this.clienteExpress='Boleta DTE';
            this.rutExpress='1-9';
            this.envio='';
            this.ntipoDte=22;
            const timestamp = Date.now();
            this.orden=this.vendedor+''+timestamp.toString();
            this.tipo_descuento='%';
            this.valor_descuento=0;
            this.discount=0;
            this.btn_descuento=false;

            this.voucherHTML=''
            this.boleta_PuntoCanje=''; 
            this.monto_PuntoCanje=''; 
            this.cliente_PuntoCanje='';
            this.imagen_PuntoCanje='';
            this.myPuntoCanje=[];
            this.numero_canje='';
            this.btn_puntos=false;
            this.nClicks=0;

            //Refrescar tablas
            await this.buscarProducto();
            await this.buscaCliente();
        },
        async enviarDTE(){
            const selectDTE=this.ntipoDte;
            const selectPago=this.pago;
            if (selectDTE!=0 && selectPago!=0){  
                this.loading=true;
                this.nClicks ++;
                if(parseInt(this.nClicks)==1){
                    const pagoMensual = await this.validaMensualidad();
                    if(pagoMensual=="si"){
                        this.myTED='';
                        //console.log(this.entidad);
                        if(this.nSucursal!=0){
                            if(this.totalNeto!=0 && this.totalVenta!=0){
                                if(this.rutExpress!='.'){
                                    if(this.pago!=''){
                                        const stateCotiza=await this.saveCotiza();
                                        if(stateCotiza){
                                            if (this.sigla=='INV') {
                                                await this.saveDTE();
                                                await this.saveCanje();
                                            } else {
                                                if (this.sigla=='NDV'){
                                                    await this.outDTE();
                                                    await this.saveCanje();
                                                } else {
                                                    this.Msg='Error de Contrato'
                                                    this.msgbox=true;
                                                    this.color='red';
                                                    this.showSnack();
                                                }
                                            }
                                        } else {
                                            this.Msg='Inconsistencia en datos'
                                            this.msgbox=true;
                                            this.color='red';
                                            this.showSnack();
                                        }
                                        this.btnGrabar=false;
                                    } else {
                                        this.Msg='Seleccione Forma de Pago'
                                        this.msgbox=true;
                                        this.color='red';
                                        this.showSnack();
                                    }
                                } else {
                                    this.Msg='Seleccione Cliente'
                                    this.msgbox=true;
                                    this.color='red';
                                    this.showSnack();
                                }
                            } else {
                                this.Msg='Sin Total para vender'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }
                        } else {
                            this.Msg='Vendedor sin Sucursal'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    } else {
                        this.d_mensualidad=true;
                    }
                }
                this.loading=false;
            } else {
                this.Msg='Seleccione DTE y Pago'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async saveCotiza(){
            let todos='si';
            if(this.items.length!=0){
                for (let index = 0; index < this.items.length; index++) {
                    const element = this.items[index];
                    var parametros={
                        'contrato': this.contrato,
                        'orden': this.orden,
                        'entidad': this.entidad,
                        'tipo': 'Neto',
                        'cv': 'V',
                        'sku':element.sku,
                        'producto':element.producto,
                        'precio':element.valor,
                        'cantidad':element.valorCantidad,
                        'descuento': element.descuento,
                        'concepto': element.concepto,
                        'bodega': element.bodega,
                        'observa':'',
                        'usuario':this.usu,
                        'referencia':'0'};
                    const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/compraventa/nueva/v5',parametros);
                    const datos=response.data;
                    //console.log(datos);
                    if (datos!='si'){ 
                        todos='no'
                    }
                };
                if(todos!='si'){
                    // eliminar cotiza
                    const response = await axios.delete(process.env.VUE_APP_URL + '/api/inv/orden/delete/'+this.contrato+'/'+this.orden);
                    const datos=response.data;
                    return false;
                } else {
                    console.log('Cotizacion Grabada');
                    return true
                }
            } else {
                return false
            }
        },
        async search_myRut(){
            try {
                //obtenemos los datos del emisor
                const resToken = await axios.get(process.env.VUE_APP_URL + '/api/inv/token/access/'+this.contrato);
                const respuesta = resToken.data;
                if (respuesta[0].existe=='si'){ 
                    this.rut_emisor = respuesta[0].Rut;
                    console.log('Rut Emisor', this.rut_emisor);
                } else { 
                    console.log('Emisor Invalido') 
                };                 
            } catch (error) {
                console.log(error)
            }
        },
        async outDTE(){
            const selectDTE=this.ntipoDte;
            const selectPago=this.pago;
            if (parseFloat(this.totalVenta)!=0){
                if (selectDTE!=0 && selectPago!=0){
                    this.loading=true;
                    this.btnGrabar=false;
                    this.OutID=0;
                    //obtener ID nuevo del dte
                    const params={
                        'contrato':this.contrato,
                        'orden':this.orden,
                        'estado':'V',
                        'usuario':this.usu
                    };
                    try {
                        const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/DTE/id/new/v2/',params);
                        const res = response.data;
                        if (res=='si'){
                            const response1 = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/id/new/v2/'+this.contrato+'/'+this.orden+'/'+this.usu);
                            const res1 = response1.data;
                            if (res1[0].existe=='si'){
                                this.OutID=parseFloat(res1[0].Folio); 
                            }                            
                        };
                        if (this.OutID!=0){
                            //console.log(this.OutID);
                            //confirmar que no existe en DTE
                            const response2 = await axios.get(process.env.VUE_APP_URL + '/api/inv/DTE/one/'+this.contrato+'/'+this.OutID);
                            const res2 = response2.data;
                            if (res2[0].existe=='no'){
                                this.html=process.env.VUE_APP_URL + '/api/inv/prt/venta/v80/'+this.contrato+'/'+this.OutID+'/'+this.entidad;
                                const paramsDTE={
                                    'contrato':this.contrato,
                                    'numero':this.OutID,
                                    'tipoDte':selectDTE,
                                    'tipoPago':selectPago,
                                    'neto':this.totalNeto,
                                    'iva':this.totalIva,
                                    'total':this.totalVenta,
                                    'fecha':this.hoy,
                                    'vencimiento':this.vencimiento,
                                    'orden':this.orden,
                                    'rutaPDF':this.html,
                                    'rutaXML':this.html,
                                    'usuario':this.usu,
                                    'sucursal':this.nSucursal,
                                    'oficina':this.office,
                                };     
                                await this.baseDTE(paramsDTE);
                                //obtener los datos para puntocanje
                                this.boleta_PuntoCanje = this.OutID; //numero de la boleta
                                this.monto_PuntoCanje = this.totalVenta; //monto de la boleta
                                this.emisor_PuntoCanje = this.rut_emisor; //rut = rut del emisor
                                this.cliente_PuntoCanje = this.rut; //pk-user = rut cliente
                                this.imagen_PuntoCanje = this.html; //ruta del Dte.
                            } else {
                                this.Msg='No Existen Folios'
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }
                        } else {
                            this.Msg='Folio No Asignado'
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    } catch (error) {
                        console.log(error)
                    }
                } else {
                    this.Msg='Seleccione DTE y Pago'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.Msg='Sin Productos'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
            this.loading=false;
        },        
        async saveDTE(){
            this.myTED='';
            this.myTokenBsale='';
            const selectDTE=this.ntipoDte;
            const selectPago=this.pago;
            if (selectDTE!=0 && selectPago!=0){                
                // obtenemos el token del contrato
                let valToken='';
                const resToken = await axios.get(process.env.VUE_APP_URL + '/api/inv/token/access/'+this.contrato);
                const respuesta = resToken.data;
                if (respuesta[0].existe=='si'){ 
                    valToken=respuesta[0].Token;
                    this.myTokenBsale = valToken;
                } else { console.log('Token Invalido') }
                // fecha cotizacion formato Bsale
                let intFecha=Date.parse(this.hoy);
                let strFecha=intFecha.toString();
                strFecha=strFecha.substring(0,10);
                const numFecha=parseFloat(strFecha);
                // fecha actual formato Bsale
                let intHoy=Date.parse(this.hoy);
                let strHoy=intHoy.toString();
                strHoy=strHoy.substring(0,10);
                const numHoy=parseFloat(strHoy);
                // fecha vencimiento formato Bsale
                let intVence=Date.parse(this.vencimiento);
                let strVence=intVence.toString();
                strVence=strVence.substring(0,10);
                const numVence=parseFloat(strVence);
                // creamos json Bsale
                let pCliente={
                    "code": this.rut,
                    "city": this.ciudad,
                    "company": this.razon,
                    "municipality": this.comuna,
                    "activity": this.giro,
                    "address": this.direccion
                };
                let pDetalle=[];
                let myDescuento = 0;
                if(this.valor_descuento!='' && this.valor_descuento!=null){
                    if(parseFloat(this.valor_descuento)!=0){
                        myDescuento = parseFloat(this.discount);
                    }
                };
                if(parseFloat(myDescuento)!=0){
                    this.items.forEach(element => {
                        pDetalle.push({
                            //"variantId":1,
                            "code": element.sku,
                            "netUnitValue":parseFloat(element.unidad).toFixed(4),
                            "quantity": parseFloat(element.valorCantidad).toFixed(4),
                            //"taxId": "[1,2]",
                            "comment": element.producto,
                            "discount": parseFloat(myDescuento),
                            "taxes": [
                                {
                                "code": 14,
                                "percentage": 19
                                }
                            ]
                        })        
                    });
                } else {
                    this.items.forEach(element => {
                        pDetalle.push({
                            //"variantId":1,
                            "netUnitValue":parseFloat(element.unidad).toFixed(4),
                            "quantity": parseFloat(element.valorCantidad).toFixed(4),
                            //"taxId": "[1,2]",
                            "comment": element.producto,
                            //"discount": parseFloat(this.valor_descuento),
                            "taxes": [
                                {
                                "code": 14,
                                "percentage": 19
                                }
                            ]
                        })        
                    });
                }
                let pPago=[
                    {
                        "paymentTypeId": selectPago,
                        "amount": this.totalVenta,
                        "recordDate": numHoy
                    }
                ];
                let pReferencia=[
                    {
                        "number": this.orden,
                        "referenceDate": numFecha,
                        "reason": "Orden de Compra "+this.orden,
                        "codeSii": 801
                    }
                ];
                //console.log(selectDTE);
                var emitDTE;
                if(selectDTE!=22){ // factura
                    emitDTE=
                    {
                        "documentTypeId": selectDTE,
                        "officeId": parseInt(this.office),
                        "emissionDate": numHoy,
                        "expirationDate": numVence,
                        "declareSii": 1,
                        //"priceListId": 18,
                        "client": pCliente,
                        "details": pDetalle,
                        "payments": pPago,
                        "references": pReferencia,
                    }
                } else { // boleta
                    emitDTE=
                    {
                        "documentTypeId": selectDTE,
                        //"documentTypeId": 39,
                        "officeId": parseInt(this.office),
                        //"officeId": 1,
                        "emissionDate": numHoy,
                        "expirationDate": numHoy,
                        "declareSii": 1,
                        //"priceListId": 18,
                        "details": pDetalle
                        //"payments": pPago,
                    }
                }
                // consumir api Bsale para crear DTE
                let resDTE =[];
                //console.log(valToken);
                //console.log(emitDTE);
                try {
                    console.log('emitDTE',emitDTE)
                    const response = await axios.post('https://api.bsale.io/v1/documents.json', emitDTE , {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
                    resDTE = response.data;
                    console.log('resDTE',resDTE);
                } catch (error) {
                    console.log (error);
                }
                if (resDTE.length!=0){
                    await this.prt_voucher();
                    this.envioDTE(this.envio,resDTE.urlPdf,resDTE.urlXml);
                    this.html=resDTE.urlPdf;
                    this.btnPrt=true;
                    //this.btnGrabar=false;
                    this.OutID=0;
                    this.OutID=resDTE.number;
                    this.myTED=resDTE.ted;
                    const paramsDTE={
                        'contrato':this.contrato,
                        'numero':resDTE.number,
                        'tipoDte':selectDTE,
                        'tipoPago':selectPago,
                        'neto':this.totalNeto,
                        'iva':this.totalIva,
                        'total':this.totalVenta,
                        'fecha':this.hoy,
                        'vencimiento':this.vencimiento,
                        'orden':this.orden,
                        'rutaPDF':resDTE.urlPdf,
                        'rutaXML':resDTE.urlXml,
                        'usuario':this.usu,
                        'sucursal':this.nSucursal,
                        'oficina':this.office,
                    };
                    await this.baseDTE(paramsDTE);
                    //obtener los datos para puntocanje
                    this.boleta_PuntoCanje = this.OutID; //numero de la boleta
                    this.monto_PuntoCanje = this.totalVenta; //monto de la boleta
                    this.emisor_PuntoCanje = this.rut_emisor; //rut = rut del emisor
                    this.cliente_PuntoCanje = this.rut; //pk-user = rut cliente
                    this.imagen_PuntoCanje = this.html; //ruta del Dte.                    
                } else {
                    this.Msg='DTE no enviado'
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
                //console.log(res);
            } else {
                this.Msg='Seleccione DTE y Pago'
                this.msgbox=true;
                this.color='red';
                this.showSnack();
            }
        },
        async baseDTE(parametrosDTE){
            const response = await axios.post(process.env.VUE_APP_URL + '/api/inv/v2/DTE/nueva',parametrosDTE);
            const datos=response.data;
            //console.log(parametrosDTE);
            if (datos=='si'){ 
                await this.updateReferencia();
                if(parseInt(this.search_id)!=0){
                    await this.deletePendiente();
                }
            } else {
                this.Msg='DTE enviado sin registro Local'
                this.msgbox=true;
                this.color='warning';
                this.showSnack();
            }
        },
        async updateReferencia(){
            var parametros0={'numero': this.OutID};
            const response0 = await axios.put(process.env.VUE_APP_URL + '/api/inv/referencia/actualiza/'+this.contrato+'/'+this.orden+'/'+this.entidad,parametros0);
            const datos0=response0.data;
            //console.log(datos0);
             if (datos0=='si'){
                await this.UpdateStock();
             } else {
                this.Msg='DTE enviado sin Referencia';
                this.msgbox=true;
                this.color='warning';
                this.showSnack();
             }
        },
        async UpdateStock(){
            let t=0;
            if (this.items.length!=0) {
                for (var i = 0; i < this.items.length; i++) {
                    var parametros1={
                            'contrato': this.contrato,
                            'sku': this.items[i].sku,
                            'cantidad': this.items[i].valorCantidad,
                            'signo': '0-',
                            'bodega': this.items[i].bodega,
                            'usuario': this.usu,
                            'observa': '',
                            'origen':'Venta'};
                    const response1 = await axios.post(process.env.VUE_APP_URL + '/api/inv/stock',parametros1);
                    const datos1=response1.data;
                    if (datos1=='si'){ t++ }
                };
                if (t!=this.items.length) {
                    this.Msg='DTE enviado sin actualizar Stock';
                    this.msgbox=true;
                    this.color='warning';
                    this.showSnack();
                } else {
                    this.btnPrt=true;
                    this.Msg='DTE exitoso';
                    this.msgbox=true;
                    this.color='success';
                    this.showSnack();
                }
            }
        },
        async fileCSV(){
            if (this.btnPrt===true){
                this.loading=true;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/fileCsv/venta/'+this.contrato+'/'+this.OutID+'/'+this.entidad);
                const datos=response.data;
                //console.log(datos);
                if (datos=='si'){
                    this.descargaCSV=true;
                    this.rutaCSV=process.env.VUE_APP_URL + '/buzon/'+this.contrato+'/'+this.OutID+'.csv';
                }
                this.loading=false;
            }
        },        
        async envioDTE(datoEnvio,datoPDF,datoXML){
            if (datoEnvio!=null && datoEnvio!=''){
                let InstFormData = new FormData();
                InstFormData.append('email' , datoEnvio);
                InstFormData.append('pdf' , datoPDF);
                InstFormData.append('xml' , datoXML);
                InstFormData.append('vch' , this.voucherHTML);
                const response= await axios.post(process.env.VUE_APP_URL + '/api/server/sender/v5', InstFormData , {headers : {'content-type': 'multipart/form-data'}});
                console.log(response.data)
            }
        },
        async deleteFila(fila){
            let imp = 0;            
            if(parseFloat(this.impuesto)!=0){ imp = 1 + (this.impuesto/100) };

            this.totalVenta=this.totalVenta-(parseFloat(fila.valor)*parseFloat(fila.valorCantidad));
            
            this.totalNeto=this.totalVenta;
            if(parseFloat(imp)!=0){ this.totalNeto = this.totalVenta/imp };
            //this.totalNeto=parseFloat(this.totalNeto).toFixed(2);
            this.mto_totalNeto=parseFloat(this.totalNeto).toFixed(2);

            this.totalIva=(this.totalNeto*this.impuesto)/100;
            //this.totalIva=parseFloat(this.totalIva).toFixed(2);
            this.mto_totalIva=parseFloat(this.totalIva).toFixed(2);

            //asignar total
            this.mto_totalVenta=parseFloat(this.totalVenta);

            if(parseFloat(this.totalNeto)<=0 || parseFloat(this.totalVenta)<=0){
                this.totalNeto=0;
                this.totalIva=0;
                this.totalVenta=0;
                this.mto_totalNeto=0;
                this.mto_totalIva=0;
                this.mto_totalVenta=0;
            };
            this.items = this.items.filter(function(dat) {
                 return dat.sku !== fila.sku; 
            });
            this.focusBarra();
        },
        async menos(fila){
            let imp = 0;            
            if(parseFloat(this.impuesto)!=0){ imp = 1 + (this.impuesto/100) };

            if(parseFloat(fila.valorCantidad)>1){
                fila.valorCantidad=parseFloat(fila.valorCantidad)-1;
                //let imp=1+(this.impuesto/100);
                if(fila.medida=='UN'){
                    fila.cantidad=new Intl.NumberFormat("de-DE").format(parseFloat(fila.valorCantidad));
                } else {
                    fila.cantidad=new Intl.NumberFormat("de-DE").format(parseFloat(fila.valorCantidad).toFixed(3));
                };
                this.totalVenta=this.totalVenta-parseFloat(fila.valor);
                // this.totalNeto=this.totalVenta/imp;
                // this.totalNeto=parseFloat(this.totalNeto).toFixed(2);
                // this.totalIva=(this.totalNeto*this.impuesto)/100;
                // this.totalIva=parseFloat(this.totalIva).toFixed(2);
                // this.totalAjuste=this.totalVenta-(this.totalNeto+this.totalIva);
                // this.totalAjuste=0;
                // this.focusBarra();
            } else {
                if (parseFloat(fila.valorCantidad)>0){
                    this.totalVenta=parseFloat(this.totalVenta)-(parseFloat(fila.valor)*parseFloat(fila.valorCantidad));
                    fila.valorCantidad=0;
                    fila.cantidad=0;
                }
            };
            this.totalNeto=this.totalVenta;
            if(parseFloat(imp)!=0){ this.totalNeto = this.totalVenta/imp };
            //this.totalNeto=parseFloat(this.totalNeto).toFixed(2);
            this.mto_totalNeto=parseFloat(this.totalNeto).toFixed(2);
            this.totalIva=(this.totalNeto*this.impuesto)/100;
            //this.totalIva=parseFloat(this.totalIva).toFixed(2);
            this.mto_totalIva=parseFloat(this.totalIva).toFixed(2);
            //asignar total
            this.mto_totalVenta=parseFloat(this.totalVenta);

            if(parseFloat(this.totalNeto)<=0 || parseFloat(this.totalVenta)<=0){
                this.totalNeto=0;
                this.totalIva=0;
                this.totalVenta=0;
                this.mto_totalNeto=0;
                this.mto_totalIva=0;
                this.mto_totalVenta=0;
            };

            //Ajuste no aplica para esta app
            this.totalAjuste=this.totalVenta-(this.totalNeto+this.totalIva);
            this.totalAjuste=0;
            if(parseFloat(fila.valorCantidad)<=0){
                this.items = this.items.filter(function(dat) {
                    return dat.sku !== fila.sku; 
                });
            };
            this.focusBarra();
        },
        changePrice(fila,newPrecio){
            fila.descuento=0;
            this.savePrecio(fila,newPrecio)
        },     
        savePrecio(fila,newPrecio){
            if(newPrecio!=''){
                if(parseFloat(newPrecio)!=0){
                    let imp = 0;
                    let newUnidad = newPrecio;
                    if(parseFloat(this.impuesto)!=0){ 
                        imp = 1 + (this.impuesto/100);
                        newUnidad = newPrecio/imp 
                    };
                    const resta=(parseFloat(fila.valor)*parseFloat(fila.valorCantidad));
                    this.totalVenta=this.totalVenta-parseFloat(resta);
                    const suma=(parseFloat(newPrecio)*parseFloat(fila.valorCantidad));
                    this.totalVenta=parseFloat(this.totalVenta)+parseFloat(suma);
                    fila.valor=newPrecio;
                    fila.precio=new Intl.NumberFormat("de-DE").format(parseFloat(newPrecio));
                    fila.unidad=newUnidad;

                    this.totalNeto=this.totalVenta;
                    if(parseFloat(imp)!=0){ this.totalNeto = this.totalVenta/imp };
                    //this.totalNeto=parseFloat(this.totalNeto).toFixed(2);
                    this.mto_totalNeto=parseFloat(this.totalNeto).toFixed(2);

                    this.totalIva=(this.totalNeto*this.impuesto)/100;
                    //this.totalIva=parseFloat(this.totalIva).toFixed(2);
                    this.mto_totalIva=parseFloat(this.totalIva).toFixed(2);
                    
                    //ajuste no aplica para esta app
                    this.totalAjuste=this.totalVenta-(this.totalNeto+this.totalIva);
                    this.totalAjuste=0;

                    //asignar total
                    this.mto_totalVenta=parseFloat(this.totalVenta);

                    if(parseFloat(this.totalNeto)<=0 || parseFloat(this.totalVenta)<=0){
                        this.totalNeto=0;
                        this.totalIva=0;
                        this.totalVenta=0;
                        this.mto_totalNeto=0;
                        this.mto_totalIva=0;
                        this.mto_totalVenta=0;
                    }

                    this.editPrecio='';
                }
            };
            this.focusBarra();
        },
        async aplicar_descuento(){
            // sku: element.Sku,
            // producto: element.Producto,
            // precio: new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
            // valor: parseFloat(element.Precio),
            // unidad: unidad,
            // cantidad: new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
            // valorCantidad: parseFloat(element.Cantidad),
            // medida:element.Medida,
            // bodega:this.nBodega
            if(this.items.length!=0){
                if(this.valor_descuento!='' && this.valor_descuento!=null){
                    if(parseFloat(this.valor_descuento)!=0){
                        let nuevo_neto = 0;
                        if(this.tipo_descuento=='%'){
                            //calcular el descuento de cada unidad para sumar los totales
                            this.discount=this.valor_descuento;
                            nuevo_neto = 0;
                            this.items.forEach(element => {
                                const myUnidad = parseFloat(element.unidad).toFixed(2);
                                const descuento_item = parseFloat(((parseFloat(element.unidad)*parseFloat(element.cantidad))*(parseFloat(this.valor_descuento)/100)) + parseFloat(0.1)).toFixed(1);
                                const total_item = parseFloat((parseFloat(myUnidad)*parseFloat(element.cantidad)) - parseFloat(descuento_item)).toFixed(2);
                                const nueva_unidad = parseFloat(parseFloat(total_item) / parseFloat(element.cantidad)).toFixed(2);
                                nuevo_neto = parseFloat(nuevo_neto) + parseFloat(total_item);
                                console.log(myUnidad, descuento_item, total_item, nueva_unidad);

                                //const descuento_precio = parseFloat(parseFloat(element.valor)*(parseFloat(this.valor_descuento)/100)).toFixed(6);
                                //const nuevo_precio = parseFloat(element.valor) - parseFloat(descuento_precio);
                                const precio_iva = parseFloat(nueva_unidad) * (this.impuesto/100);
                                const nuevo_precio = parseFloat(nueva_unidad) + parseFloat(precio_iva);
                                element.precio = new Intl.NumberFormat("de-DE").format(parseFloat(nuevo_precio).toFixed(2));
                                element.valor = parseFloat(nuevo_precio)
                                
                            });
                            //calcular totales con nuevo neto
                            const nuevo_iva = parseFloat(nuevo_neto) * (this.impuesto/100);
                            const nuevo_total = parseFloat(nuevo_neto) + parseFloat(nuevo_iva);

                            this.totalNeto=parseFloat(nuevo_neto);
                            this.totalIva=parseFloat(nuevo_iva);
                            this.totalVenta=parseFloat(nuevo_total);
                            this.mto_totalNeto=parseFloat(nuevo_neto).toFixed(2);
                            this.mto_totalIva=parseFloat(nuevo_iva).toFixed(2);
                            this.mto_totalVenta=parseFloat(nuevo_total).toFixed(2);
                        }
                        if(this.tipo_descuento=='$'){
                            //obtener el porcentaje de descuento
                            const nuevo_porcentaje = parseFloat((parseFloat(this.valor_descuento)*100)/parseFloat(this.totalVenta)).toFixed(6);
                            this.discount = nuevo_porcentaje;
                            let nuevo_subtotal = 0;
                            this.items.forEach(element => {
                                const myValor = parseFloat(element.valor);
                                const descuento_valor = parseFloat(myValor)*(parseFloat(nuevo_porcentaje)/100);
                                const nuevo_valor = parseFloat(parseFloat(myValor) - parseFloat(descuento_valor)).toFixed(2);
                                element.precio = new Intl.NumberFormat("de-DE").format(parseFloat(nuevo_valor).toFixed(2));
                                element.valor = parseFloat(nuevo_valor);
                                const subtotal_item =  parseFloat(nuevo_valor) * parseFloat(element.cantidad);
                                nuevo_subtotal = parseFloat(nuevo_subtotal) + parseFloat(subtotal_item);
                                // const myUnidad = parseFloat(element.unidad).toFixed(2);
                                // const descuento_item = parseFloat(((parseFloat(element.unidad)*parseFloat(element.cantidad))*(parseFloat(nuevo_porcentaje)/100)) + parseFloat(0.1)).toFixed(1);
                                // const total_item = parseFloat((parseFloat(myUnidad)*parseFloat(element.cantidad)) - parseFloat(descuento_item)).toFixed(2);
                                // const nueva_unidad = parseFloat(parseFloat(total_item) / parseFloat(element.cantidad)).toFixed(2);
                                // nuevo_neto = parseFloat(nuevo_neto) + parseFloat(total_item);
                                // console.log(myUnidad, descuento_item, total_item, nueva_unidad);

                                // const precio_iva = parseFloat(nueva_unidad) * (this.impuesto/100);
                                // const nuevo_precio = parseFloat(nueva_unidad) + parseFloat(precio_iva);
                                // element.precio = new Intl.NumberFormat("de-DE").format(parseFloat(nuevo_precio).toFixed(2));
                                // element.valor = parseFloat(nuevo_precio)
                            });
                            //calcular totales
                            let imp = 0;            
                            if(parseFloat(this.impuesto)!=0){ imp = 1 + (this.impuesto/100) };

                            let nuevo_neto_total = parseFloat(nuevo_subtotal);
                            if(parseFloat(imp)!=0){ nuevo_neto_total = parseFloat(nuevo_subtotal)/parseFloat(imp) };

                            const nuevo_iva = parseFloat(nuevo_neto_total) * (this.impuesto/100);
                            const nuevo_total = parseFloat(nuevo_subtotal);

                            this.totalNeto=parseFloat(nuevo_neto_total);
                            this.totalIva=parseFloat(nuevo_iva);
                            this.totalVenta=parseFloat(nuevo_total);
                            this.mto_totalNeto=parseFloat(nuevo_neto_total).toFixed(2);
                            this.mto_totalIva=parseFloat(nuevo_iva).toFixed(2);
                            this.mto_totalVenta=parseFloat(nuevo_total).toFixed(2);
                        };
                        this.btn_descuento=true;
                        this.d_descuento=true;
                    }
                } else {
                    this.Msg='Ingrese valor de descuento';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } else {
                this.valor_descuento=0;
            }
        },

        save(fila,newCantidad) {
            console.log('save');
            if(!isNaN(newCantidad)){
                newCantidad=newCantidad;
            } else {
                this.Msg='Cantidad Invalida';
                this.msgbox=true;
                this.color='red';
                this.showSnack();
                newCantidad='';
            };
            if(newCantidad!=''){
                if(parseFloat(newCantidad)!=0){
                    //verificamos el stock
                    const resultado = this.inventalista.find( datos => datos.sku === fila.sku );
                    if (resultado){
                        if(parseFloat(resultado.stockSku)>=parseFloat(newCantidad)){
                            
                            let imp = 0;            
                            if(parseFloat(this.impuesto)!=0){ imp = 1 + (this.impuesto/100) };

                            const resta=(parseFloat(fila.valor)*parseFloat(fila.valorCantidad));
                            this.totalVenta=parseFloat(this.totalVenta)-parseFloat(resta);
                            const suma=(parseFloat(fila.valor)*parseFloat(newCantidad));
                            this.totalVenta=parseFloat(this.totalVenta)+parseFloat(suma);
                            if(fila.medida=='UN'){
                                fila.cantidad=new Intl.NumberFormat("de-DE").format(parseFloat(newCantidad));
                            } else {
                                fila.cantidad=new Intl.NumberFormat("de-DE").format(parseFloat(parseFloat(newCantidad).toFixed(3)));
                            };
                            fila.valorCantidad=newCantidad;

                            this.totalNeto=this.totalVenta;
                            if(parseFloat(imp)!=0){ this.totalNeto = this.totalVenta/imp };                            
                            
                            //this.totalNeto=parseFloat(this.totalNeto).toFixed(2);
                            this.mto_totalNeto=parseFloat(this.totalNeto).toFixed(2);

                            this.totalIva=(this.totalNeto*this.impuesto)/100;
                            //this.totalIva=parseFloat(this.totalIva).toFixed(2);
                            this.mto_totalIva=parseFloat(this.totalIva).toFixed(2);

                            //asignar total
                            this.mto_totalVenta=parseFloat(this.totalVenta);

                            if(parseFloat(this.totalNeto)<=0 || parseFloat(this.totalVenta)<=0){
                                this.totalNeto=0;
                                this.totalIva=0;
                                this.totalVenta=0;
                                this.mto_totalNeto=0;
                                this.mto_totalIva=0;
                                this.mto_totalVenta=0;
                            }
                            this.editCantidad='';
                        } else {
                            this.Msg='Cantidad Supera Stock';
                            this.msgbox=true;
                            this.color='red';
                            this.showSnack();
                        }
                    }
                }
            };
            this.focusBarra();
        },
        cancel(fila) {
            console.log('cancel');
            this.editCantidad='';
            this.editPrecio='';
            this.focusBarra();
        },
        open(fila) {
            console.log('open');
            this.editCantidad='';
            this.editPrecio='';
            this.focusBarra();
        },
        close(fila) {
            console.log('close');
            this.editCantidad='';
            this.editPrecio='';
            this.focusBarra();
        },
        async add_pendiente(){
            try {
                if(this.items.length!=0){
                    let lineas = 0;
                    const timestamp = new Date();
                    const v_anio = ''+timestamp.getFullYear();
                    const v_mes = ''+(timestamp.getMonth() + 1);
                    const v_dia = ''+timestamp.getDate();
                    const v_hora = ''+timestamp.getHours();
                    const v_minuto = ''+timestamp.getMinutes();
                    const v_segundo = ''+timestamp.getSeconds();
                    const var_id = v_anio + v_mes + v_dia + v_hora + v_minuto + v_segundo;
                    const var_fecha = (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substring(0, 10);
                    const var_hora = v_hora + ':' + v_minuto;
                    for (let index = 0; index < this.items.length; index++) {
                        const element = this.items[index];
                        const params = {
                            id: var_id,
                            contrato: this.contrato,
                            fecha: var_fecha, 
                            hora: var_hora,
                            sku: element.sku,
                            producto: element.producto,
                            medida: element.medida,
                            cantidad: element.valorCantidad,
                            precio: element.valor,
                            descuento: element.descuento,
                            concepto: element.concepto,
                            usuario: this.usu
                        };
                        const response1 = await axios.post(process.env.VUE_APP_URL + '/api/inv/save/pendiente/express/v5',params);
                        const datos1=response1.data;
                        if (datos1=='si'){ lineas ++ }
                    };
                    if(lineas!=0){
                        this.Msg='Productos reservados de la lista';
                        this.msgbox=true;
                        this.color='success';
                        this.showSnack();
                        await this.search_pendientes();
                        await this.nuevaVenta();
                    }
                } else {
                    this.Msg='No existen productos en la lista';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            }
        },
        async search_pendientes(){
            try {
                this.pendientelista=[];
                this.pendientecuenta=0;
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/search/pendiente/express/'+this.contrato+'/'+this.usu);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    datos.forEach(element => {
                        this.pendientelista.push({
                            pen_id: element.ID,
                            pen_fecha: element.Fecha,
                            pen_hora: element.Hora,
                            pen_total: element.Total
                        }); this.pendientecuenta++
                    });
                }
            } catch (error) {
                console.log(error)
            }
        },
        async handlePendiente(fila){
            this.valor_descuento=0;
            this.pendiente=false;
            await this.nuevaVenta();
            this.search_id= fila.pen_id;
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/search/pendiente/express/'+this.contrato+'/'+this.usu+'/'+this.search_id);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    let imp = 1+(parseFloat(this.impuesto)/100);
                    datos.forEach(element => {
                        let unidad=parseFloat(element.Precio)/imp;
                        this.items.push({
                            sku: element.Sku,
                            producto: element.Producto,
                            precio: new Intl.NumberFormat("de-DE").format(parseFloat(element.Precio)),
                            valor: parseFloat(element.Precio),
                            unidad: unidad,
                            cantidad: new Intl.NumberFormat("de-DE").format(parseFloat(element.Cantidad)),
                            valorCantidad: parseFloat(element.Cantidad),
                            medida:element.Medida,
                            bodega:this.nBodega,
                            original: parseFloat(element.Precio),
                            descuento: element.Descuento,
                            concepto: element.Concepto,
                        });
                        //recalculamos los totales
                        const precio_item=parseFloat(element.Precio) * parseFloat(element.Cantidad);

                        this.totalVenta=this.totalVenta+precio_item;
                        this.mto_totalVenta=this.totalVenta;

                        this.totalNeto=this.totalVenta/imp;
                        this.mto_totalNeto=parseFloat(this.totalNeto).toFixed(2);

                        this.totalIva=(this.totalNeto*this.impuesto)/100;
                        this.mto_totalIva=parseFloat(this.totalIva).toFixed(2);

                        // ajuste no aplica para esta app
                        this.totalAjuste=this.totalVenta-(this.totalNeto+this.totalIva);
                        this.totalAjuste=0;
                    });
                    if(parseFloat(this.totalNeto)<=0 || parseFloat(this.totalIva)<=0 || parseFloat(this.totalVenta)<=0){
                        this.totalNeto=0;
                        this.totalIva=0;
                        this.totalVenta=0;
                        this.mto_totalNeto=0;
                        this.mto_totalIva=0;
                        this.mto_totalVenta=0;
                    }
                }              
            } catch (error) {
                console.log(error)
            };
        },
        async deletePendiente(){
            try {
                if(this.pendientelista.length!=0){
                    const response = await axios.delete(process.env.VUE_APP_URL + '/api/inv/pendiente/express/delete/'+this.contrato+'/'+this.usu);
                    const datos=response.data;
                    if (datos=='si'){ 
                        this.search_id = 0;
                        await this.search_pendientes()
                    }
                } else {
                    this.Msg='No existen pendientes';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();
                }
            } catch (error) {
                console.log(error)
            }
        },
        async deleteLinePeniente(fila){
            this.search_id= fila.pen_id;
            await this.deletePendiente();
            this.pendiente=false;
        },
        async search_emisor(){
            let result = [];
            try {
                const response = await axios.get(process.env.VUE_APP_URL + '/api/inv/search/emisor/dte/'+this.contrato);
                const datos=response.data;
                if (datos[0].existe=='si'){
                    console.log('oficina usuario', this.office)
                    console.log('datos emisor', datos)
                    datos.forEach(element => {
                        if(parseInt(element.Oficina) == parseInt(this.office)){
                            result = element;
                        }
                    })                    
                }
            } catch (error) {
                console.log(error)
            };
            return result
        },
        // async search_DTE(){
        //     this.loading=true;
        //     let array_PDF=[];
        //     try {
        //         //const number_dte ='8916329295';
        //         //const valToken = 'faf20d0b0f394d5c7bfffb514ee5988bbced23a7';
        //         const number_dte = this.OutID;
        //         const valToken = this.myTokenBsale;
        //         let res = null;
        //         let myEmisor;
        //         let myCliente;
        //         let myDetalle=[];
        //         let myTotales;
        //         let myReferencia;
        //         let myFechas;
        //         let myDocumento;
        //         let myDescuentos=[];
        //         const data_emisor = await this.search_emisor();
        //         if(data_emisor.length!=0){
        //             myEmisor = data_emisor[0];
        //             if(parseInt(this.ntipoDte)==22){ // boleta
        //                 res = await axios.get('https://api.bsale.cl/v1/documents.json?number=' + number_dte + '&codesii=39', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
        //             };
        //             if(parseInt(this.ntipoDte)==5){ // factura
        //                 res = await axios.get('https://api.bsale.cl/v1/documents.json?number=' + number_dte + '&codesii=33', {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
        //             };
        //             if( res!=null ){
        //                 let documento='';
        //                 if(parseInt(this.ntipoDte)==22){ documento = 'BOLETA ELECTRÓNICA' }; // boleta
        //                 if(parseInt(this.ntipoDte)==5){ documento = 'FACTURA ELECTRÓNICA' }; // factura                        
        //                 const dato = res.data;
        //                 const nID_Venta = dato.items[0].id;
        //                 //obtener los datos del cliente
        //                 const uri_cli = dato.items[0].client.href;
        //                 const res_cli = await axios.get(uri_cli, {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
        //                 const data_cli = res_cli.data;
        //                 if(data_cli.length!=0){
        //                     myCliente = {
        //                         "rut": data_cli.code,
        //                         "razon": data_cli.company,
        //                         "giro": data_cli.activity,
        //                         "direccion": data_cli.address,
        //                         "comuna": data_cli.municipality,
        //                         "ciudad": data_cli.city,
        //                         "telefono" : data_cli.phone,
        //                         "email" : data_cli.email
        //                     }
        //                 };
        //                 //obtener las referencias del documento
        //                 const uri_ref = dato.items[0].references.href;
        //                 const res_ref = await axios.get(uri_ref, {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
        //                 const data_ref = res_ref.data;
        //                 if(parseInt(data_ref.count)!=0){
        //                     //fecha ref
        //                     const fec_ref = new Date(data_ref.items[0].referenceDate * 1000).toISOString();
        //                     const date_ref = fec_ref.substring(0,10);
        //                     myReferencia = {
        //                         "folio": data_ref.items[0].number,
        //                         "fecha": this.fechaNacional(date_ref),
        //                         "tipo": "Orden de Compra",
        //                         "razon": data_ref.items[0].reason
        //                     };
        //                 };
        //                 //fecha emision
        //                 const fec_emis = new Date(dato.items[0].emissionDate * 1000).toISOString();
        //                 const date_emis = fec_emis.substring(0,10);
        //                 //fecha vence
        //                 const fec_vence = new Date(dato.items[0].expirationDate * 1000).toISOString();
        //                 const date_vence = fec_vence.substring(0,10);
        //                 myFechas = {
        //                     "emision": this.fechaNacional(date_emis),
        //                     "vencimiento": this.fechaNacional(date_vence),
        //                 };
        //                 //totales
        //                 myTotales = {
        //                     "neto": dato.items[0].netAmount,
        //                     "impuesto": this.impuesto,
        //                     "iva": dato.items[0].taxAmount,
        //                     "total": dato.items[0].totalAmount,
        //                 };
        //                 //api bsale para rescatar id detalle de venta
        //                 let offset = 0;
        //                 const responseD = await axios.get('https://api.bsale.cl/v1/documents/'+nID_Venta+'/details.json?limit=50&offset=' + offset, {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
        //                 const resDetails = responseD.data;
        //                 if (resDetails.items.length!=0){
        //                     resDetails.items.forEach(element => {
        //                         myDetalle.push({
        //                             "sku": element.variant.code,
        //                             "producto": element.variant.description,
        //                             "precio": element.netUnitValue,
        //                             "cantidad": element.quantity
        //                         })
        //                     })
        //                 };
        //                 //datos Documento
        //                 const uri_office = dato.items[0].office.href;
        //                 const res_office = await axios.get(uri_office, {headers : {"Accept":"application/json","content-type":"application/json","access_token":valToken}});
        //                 const data_office = res_office.data;
        //                 myDocumento = {
        //                     "folio": number_dte,
        //                     "documento": documento,
        //                     "ted": dato.items[0].ted,
        //                     "sucursal": data_office.description
        //                 };
        //                 //descuentos
        //                 const res_dscto = await axios.get(process.env.VUE_APP_URL + '/api/inv/descuentos/' + this.contrato + '/' + this.ntipoDte + '/' + number_dte);
        //                 const data_dscto = res_dscto.data;
        //                 if (data_dscto[0].existe=='si'){
        //                     for (let index = 0; index < data_dscto.length; index++) {
        //                         const element = data_dscto[index];
        //                         myDescuentos.push({
        //                             "sku": element.Sku,
        //                             "producto": element.Producto,
        //                             "precio": element.Precio,
        //                             "cantidad": element.Cantidad,
        //                             "descuento": element.Descuento,
        //                             "concepto": element.Concepto,
        //                         })                                
        //                     }
        //                 };
        //                 array_PDF = {
        //                     "myEmisor" : myEmisor,
        //                     "myCliente" : myCliente,
        //                     "myDetalle" : myDetalle,
        //                     "myTotales" : myTotales,
        //                     "myReferencia" : myReferencia,
        //                     "myFechas" : myFechas,
        //                     "myDocumento" : myDocumento,
        //                     "myDescuentos": myDescuentos
        //                 };
        //                 await this.verPDF(array_PDF);
        //             } else {
        //                 this.Msg='no es posible obtener el Documento PDF, informar a soporte';
        //                 this.msgbox=true;
        //                 this.color='red';
        //                 this.showSnack();
        //             }
        //         } else {
        //             this.Msg='No es posible leer datos del Emisor';
        //             this.msgbox=true;
        //             this.color='red';
        //             this.showSnack();
        //         }
        //     } catch (error) {
        //         console.log(error)
        //         this.Msg='Algo anda mal con la lectura del DTE, informar a soporte';
        //         this.msgbox=true;
        //         this.color='red';
        //         this.showSnack();
        //     };
        //     this.loading=false;
        // },
        async verPDF(array_PDF){
            let myEmisor = array_PDF.myEmisor;
            let myCliente = array_PDF.myCliente;
            let myDetalle = array_PDF.myDetalle;
            let myTotales = array_PDF.myTotales;
            let myReferencia = array_PDF.myReferencia;
            let myFechas = array_PDF.myFechas;
            let myDocumento = array_PDF.myDocumento;
            let myDescuentos = array_PDF.myDescuentos;
            const total_items = myDetalle.length;
            let base = 0
            if(this.sigla=='INV'){ base = 152 };
            if(this.sigla=='NDV'){ base = 112 };
            const ancho = 80;
            const largo = (parseInt(total_items) * 4) + parseInt(base);
            const hoja = [ancho,largo];
            const doc = new jsPDF('p', 'mm', hoja);
            //const image = fs.readFileSync('Clientes/TerraFirma/logoTerra.jpg');
            //doc.addImage(image, 'JPEG', 2, 7, 45, 20);
            //doc.setDrawColor(255,0,0);
            //grosor linea
            doc.setLineWidth(0.5);
            //horizontal lines
            doc.line(30, 5, 75, 5);
            doc.line(30, 25, 75, 25);
            //vertical lines
            doc.line(30, 5, 30, 25);
            doc.line(75, 5, 75, 25);

            //tipo de letra bold = negrita y normal = normal
            doc.setFont("arial", "bold");
            //tamaño de letra
            doc.setFontSize(9);
            //doc.setTextColor(255,0,0);
            //formateo de rut emisor
            var tmp 	= myEmisor.Rut.split('-');
		    var digv	= tmp[1]; 
		    var ruti 	= tmp[0];
            const format_rut = new Intl.NumberFormat("de-DE").format(ruti);
            const rut_emisor = ''+format_rut+'-'+digv;
            doc.text('R.U.T. : ' + (''+rut_emisor).toUpperCase(), 52.5, 10, { align: "center" });
            doc.text(myDocumento.documento, 52.5, 15, { align: "center" });
            doc.text('N° ' + myDocumento.folio, 52.5, 20, { align: "center" });

            if(this.sigla=='INV'){ 
                doc.text('S.I.I.' , 52.5, 28, { align: "center" });
            }
            
            doc.setLineWidth(0.2);
            doc.line(2, 32, 78, 32);

            //datos emisor
            doc.setFont("arial", "bold");
            doc.setFontSize(8);

            const anchoRazon = 78;
            let space_line = 3;
            let line = 37;
            let suma_line = 0;
            
            const razon_emisor = myEmisor.Razon_Social;
            const parrafo_razon = doc.splitTextToSize((''+razon_emisor).toUpperCase(), anchoRazon);
            doc.text(parrafo_razon, 39, line, {align: 'center',lineHeightFactor: 1.5,maxWidth:78});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_razon.length) * space_line;
            line = line + suma_line + space_line;

            const anchoEmisor = 60;
            space_line = 2

            doc.setFont("arial", "normal");
            doc.setFontSize(6);

            doc.text('GIRO: ', 2, line);
            const giro_emisor = myEmisor.Giro;
            const parrafo_giro = doc.splitTextToSize((''+giro_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_giro, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_giro.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('DIRECCIÓN: ', 2, line);
            const direccion_emisor = myEmisor.Direccion;
            const parrafo_direccion = doc.splitTextToSize((''+direccion_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_direccion, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_direccion.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('COMUNA: ', 2, line);
            const comuna_emisor = myEmisor.Comuna;
            doc.text((''+comuna_emisor).toUpperCase(), 15, line);

            doc.text('CIUDAD: ', 45, line);
            const ciudad_emisor = myEmisor.Ciudad
            doc.text((''+ciudad_emisor).toUpperCase(), 55, line);

            //sumar las lineas del parrafo
            suma_line = 2
            line = line + suma_line + space_line;
            
            doc.text('SUCURSAL: ', 2, line);
            const sucursal_emisor = myDocumento.sucursal;
            const parrafo_sucursal = doc.splitTextToSize((''+sucursal_emisor).toUpperCase(), anchoEmisor);
            doc.text(parrafo_sucursal, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = 0;
            line = line + suma_line + space_line;

            doc.setLineWidth(0.2);
            doc.line(2, line, 78, line);

            line = line + 4;

            //datos cliente

            doc.text('CLIENTE: ', 2, line);
            const razon_cliente = myCliente.razon;
            const parrafo_cliente = doc.splitTextToSize((''+razon_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_cliente, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_cliente.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('RUT: ', 2, line);
            const rut_cliente = myCliente.rut;
            const parrafo_rut = doc.splitTextToSize((''+rut_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_rut, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_rut.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('GIRO: ', 2, line);
            const giro_cliente = myCliente.giro;
            const parrafo_giro_cliente = doc.splitTextToSize((''+giro_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_giro_cliente, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_giro_cliente.length) * space_line;
            line = line + suma_line + space_line;

            doc.text('DIRECCIÓN: ', 2, line);
            const direccion_cliente = myCliente.direccion;
            const comuna_cliente = myCliente.comuna;
            const ciudad_cliente = myCliente.ciudad;
            const direccion_compuesta_cliente = direccion_cliente + ', ' + comuna_cliente + ', ' + ciudad_cliente;
            const parrafo_direccion_cliente = doc.splitTextToSize((''+direccion_compuesta_cliente).toUpperCase(), anchoEmisor);
            doc.text(parrafo_direccion_cliente, 15, line, {align: 'left',lineHeightFactor: 1.5,maxWidth:60});
            
            //sumar las lineas del parrafo
            suma_line = parseInt(parrafo_direccion_cliente.length) * space_line;
            line = line + suma_line + space_line;
 
            doc.text('FECHA EMISION: ', 2, line);
            const emision_cliente = myFechas.emision;
            doc.text(emision_cliente, 20, line);

            doc.text('FECHA VCTO.: ', 35, line);
            const vence_cliente = myFechas.vencimiento;
            doc.text(vence_cliente, 51, line);

            suma_line = 0;
            line = line + suma_line + space_line;

            // doc.text('FORMA DE PAGO: ', 2, line);
            // const pago_cliente = myPago[0].forma;
            // doc.text((''+pago_cliente).toUpperCase(), 21, line);

            // suma_line = 0;
            // line = line + suma_line + space_line;

            doc.line(2, line, 78, line);

            //detalle
            doc.setFontSize(6);
            //encabezado
            line = line + 2;
            doc.text('DESCRIPCION PRODUCTO', 2, line);
            line = line + 2;
            doc.text('CANT. X PRECIO', 2, line);
            doc.text('TOTAL', 70, line);
            line = line + 0.5;
            doc.line(2, line, 78, line);
            line = line + 0.5;
            let myDescuento = 'no';
            myDetalle.forEach(element => {
                line = line + 2;
                doc.text((''+element.producto).toUpperCase(), 2, line);
                line = line + 2;
                const format_valor = new Intl.NumberFormat("de-DE").format(parseFloat(element.precio));
                const format_cantidad = new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad));
                const precio_item = parseFloat(element.precio) * parseFloat(element.cantidad);
                const format_precio =new Intl.NumberFormat("de-DE").format(parseFloat(precio_item));
                doc.text((''+format_cantidad+' x $'+format_valor).toUpperCase(), 2, line);
                doc.text(('$'+format_precio).toUpperCase(), 78, line, {align: 'right'});
            });
            line = line + 1;
            doc.line(2, line, 78, line);
            //referencias
            if(parseInt(this.ntipoDte)==5){ // factura
                line = line + 2;
                doc.text('Referencia a otros documentos.', 2, line);
                line = line + 3;
                doc.text('TIPO DOCTO.', 2, line);
                doc.text('FOLIO.', 35, line);
                doc.text('FECHA', 67, line);
                line = line + 2;
                doc.text(myReferencia.tipo, 2, line);
                doc.text(myReferencia.folio, 35, line);
                doc.text(myReferencia.fecha, 67, line);
                line = line + 1;
                doc.line(2, line, 78, line);
            }; 
            //totales
            doc.setFont("arial", "bold");
            doc.setFontSize(7);
            line = line + 5;
            doc.text('MONTO NETO', 40, line);
            const format_neto = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.neto).toFixed(2));
            doc.text(format_neto, 78, line, {align: 'right'});
            line = line + 3;
            doc.text('IVA ('+myTotales.impuesto+'%)', 40, line);
            const format_iva = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.iva).toFixed(2));
            doc.text(format_iva, 78, line, {align: 'right'});
            line = line + 3;
            doc.text('TOTAL', 40, line);
            const format_total = new Intl.NumberFormat("de-DE").format(parseFloat(myTotales.total).toFixed(0));
            doc.text(format_total, 78, line, {align: 'right'});

            if(this.sigla=='INV'){
                //timbre
                doc.setFont("arial", "NORMAL");
                doc.setFontSize(6);
                line = line + 3;
                await this.PDF417_graphic(myDescuento.ted);
                doc.addImage(this.timbre_PDF,'JPEG',9,line,62,28);

                line = line + 30;
                doc.text('Timbre Electrónico S.I.I.' , 40, line, { align: "center" });
                line = line + 3;
                doc.text('Res. 80 del 22-08-2014 Verifique Documento en www.sii.cl' , 40, line, { align: "center" });
                line = line + 3;
                doc.text('GRACIAS POR SU COMPRA' , 40, line, { align: "center" });
            };
            if(this.sigla=='NDV'){
                line = line + 10;
                doc.text('GRACIAS POR SU COMPRA' , 40, line, { align: "center" });
            };

            //voucher de descuento
            if(myDescuentos.length!=0){
                line = line + 2;
                doc.text('Este documento adjunta voucher de descuentos' , 40, line, { align: "center" });
                //obtener el largo de los descuentos
                const base_dscto = 50;
                const largo_dscto = (parseInt(myDescuentos.length) * 4) + parseInt(base_dscto);
                const hoja_dscto = [ancho,largo_dscto];
                doc.addPage(hoja_dscto,'mm','p');

                doc.setFont("arial", "bold");
                doc.setFontSize(10);
                doc.text('Voucher de Descuentos' , 40, 10, { align: "center" });
                doc.setFont("arial", "NORMAL");
                doc.setFontSize(6);
                doc.text('Rut Emisor   : ' + (''+rut_emisor).toUpperCase(), 2, 17);
                doc.text('Razon Social : ' + (''+razon_emisor).toUpperCase(), 2, 20);
                doc.text('Fecha Dscto. : ' + emision_cliente, 50, 17);
                doc.text('Ref. Docto.  : ' + myDocumento.folio, 50, 20);
                line = 22;
                //encabezado
                doc.line(2, line, 78, line);
                line = line + 2;
                doc.text('P. ORIGINAL', 2, line);
                doc.text('DESCRIPCION PRODUCTO', 20, line);
                line = line + 2;
                doc.text('CANT. X DSCTO.', 2, line);
                doc.text('CONCEPTO DSCTO.', 20, line);
                doc.text('TOTAL', 70, line);
                line = line + 0.5;
                doc.line(2, line, 78, line);
                line = line + 0.5;
                let myTotalDscto = 0;
                myDescuentos.forEach(element => {
                    line = line + 2; 
                    const valor_original = parseFloat(element.precio) + parseFloat(element.descuento);
                    const format_original = new Intl.NumberFormat("de-DE").format(parseFloat(valor_original));
                    doc.text(('( $'+format_original+' )').toUpperCase(), 2, line);                  
                    doc.text((''+element.producto).toUpperCase(), 20, line);
                    line = line + 2;
                    const format_descuento = new Intl.NumberFormat("de-DE").format(parseFloat(element.descuento));
                    const format_cantidad = new Intl.NumberFormat("de-DE").format(parseFloat(element.cantidad));
                    const precio_item = parseFloat(element.descuento) * parseFloat(element.cantidad);
                    doc.text((''+format_cantidad+' x $'+format_descuento).toUpperCase(), 2, line);
                    doc.text((''+element.concepto).toUpperCase(), 20, line);
                    const format_precio =new Intl.NumberFormat("de-DE").format(parseFloat(precio_item));
                    doc.text(('$ -'+format_precio).toUpperCase(), 78, line, {align: 'right'});
                    myTotalDscto = parseFloat(myTotalDscto) + parseFloat(precio_item);
                });
                line = line + 1;
                doc.line(2, line, 78, line);
                line = line + 5;
                doc.setFont("arial", "bold");
                doc.setFontSize(7);
                doc.text('TOTAL', 40, line);
                const format_dscto = new Intl.NumberFormat("de-DE").format(parseFloat(myTotalDscto).toFixed(2));
                doc.text('$ -' + format_dscto, 78, line, {align: 'right'});
            };
            doc.output('dataurlnewwindow');

        },
        async PDF417_graphic(ted){
            if(ted!=null && ted!=''){
                this.timbre_PDF='';
                var data_code = ted;
                PDF417.init(data_code);           	
                var barcode = PDF417.getBarcodeArray();
                // block sizes (width and height) in pixels
                var bw = 2;
                var bh = 2;
                // create canvas element based on number of columns and rows in barcode
                const canvas = document.createElement("canvas");
                //const canvas = createCanvas(200, 200);
                canvas.width = bw * barcode['num_cols'];
                canvas.height = bh * barcode['num_rows'];
                const ctx = canvas.getContext('2d');
                // graph barcode elements
                var y = 0;
                // for each row
                for (var r = 0; r < barcode['num_rows']; ++r) {
                    var x = 0;
                    // for each column
                    for (var c = 0; c < barcode['num_cols']; ++c) {
                        if (barcode['bcode'][r][c] == 1) {                        
                            ctx.fillRect(x, y, bw, bh);
                        }
                        x += bw;
                    }
                    y += bh;
                };
                const resultado = canvas.toDataURL();
                if(resultado.substring(10)=='data:image'){
                    this.timbre_PDF=resultado;
                } else {
                    this.timbre_PDF= this.timbre_universal;
                }
            } else {
                this.timbre_PDF= this.timbre_universal;
            }
        },
        fechaNacional(fec){
            const dia = fec.substring(8,10);
            const mes = fec.substring(5,7);
            const anio = fec.substring(0,4);
            const hoy = dia + '-' + mes + '-' + anio;
            return hoy;
        },
        async prt_voucher(){
            this.voucherHTML='';
            let sumaDiscount = 0;
            this.items.forEach(element => {
                const item_descuento = parseFloat(element.cantidad)*parseFloat(element.descuento);
                sumaDiscount = parseFloat(sumaDiscount) + parseFloat(item_descuento);
            });
            if(parseFloat(sumaDiscount)!=0){
                const number_dte = this.OutID;
                this.voucherHTML=process.env.VUE_APP_URL + '/api/inv/prt/voucher/'+this.contrato+'/'+ number_dte +'/'+this.entidad;
            }
        },
        goLogin(){
            this.d_mensualidad=false;
            this.$router.push({name:'Login'});
        },
        async saveCanje(){
            if(this.numero_canje!=''){
                //buscamos el ID del canje
                const found = this.myPuntoCanje.filter(res => parseFloat(res.canje) == parseFloat(this.numero_canje));
                if(found.length!=0){
                    const myID = found[0].id;
                    //update del canje
                    try {
                        //obtener la apikey
                        const res_secret = await axios.get(process.env.VUE_APP_URL2 + '/api/v1/token/app/');
                        const data_secret = res_secret.data;
                        if(data_secret[0].existe=='ok'){
                            const mySecret = data_secret[0].token;
                            //generamos el token de usuario
                            const par_token = {
                                secret: mySecret,
                                user: this.cliente_PuntoCanje
                            };
                            const res_token = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/create/token/', par_token);
                            const data_token = res_token.data;
                            if(data_token.Token!='error'){
                                const apiKey = data_token.Token;
                                const headers = {
                                    'Content-Type' : 'application/json',
                                    'Authorization' : 'Token ' + apiKey
                                };
                                const par_user = {
                                    'user': this.cliente_PuntoCanje,
                                    'id': myID
                                }
                                const res_user = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/bodeganet/update/canje/',par_user,{headers});
                                const data_user = res_user.data;
                                if(data_user[0].existe=='ok'){
                                    console.log('canje exitoso')
                                }
                            }                        
                        }
                    } catch (error) {
                        console.log(error)
                    }
                }
            }
        },
        async add_puntos(){
            try {
                let ruts=this.validaRut(this.cliente_PuntoCanje);
                if (ruts){
                    //obtener la apikey
                    const res_secret = await axios.get(process.env.VUE_APP_URL2 + '/api/v1/token/app/');
                    const data_secret = res_secret.data;
                    if(data_secret[0].existe=='ok'){
                        const mySecret = data_secret[0].token;
                        //generamos el token de usuario
                        const par_token = {
                            secret: mySecret,
                            user: this.cliente_PuntoCanje
                        };
                        const res_token = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/create/token/', par_token);
                        const data_token = res_token.data;
                        if(data_token.Token!='error'){
                            const apiKey = data_token.Token;
                            const headers = {
                                'Content-Type' : 'application/json',
                                'Authorization' : 'Token ' + apiKey
                            };
                            const par_user = {
                                'user': this.cliente_PuntoCanje,
                                'rut':  this.emisor_PuntoCanje, 
                                'boleta': this.boleta_PuntoCanje,
                                'monto' : this.monto_PuntoCanje,
                                'base64': this.imagen_PuntoCanje,
                            }
                            const res_user = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/save/boleta/',par_user,{headers});
                            const data_user = res_user.data;
                            if(data_user[0].existe=='ok'){
                                this.btn_puntos=true;                   
                                this.Msg='Ingreso de puntos exitoso';
                                this.msgbox=true;
                                this.color='success';
                                this.showSnack();
                            } else {
                                this.Msg='no fue posible ingresar puntos';
                                this.msgbox=true;
                                this.color='success';
                                this.showSnack();
                            }
                        } else {
                            this.Msg='no fue posible crear token';
                            this.msgbox=true;
                            this.color='success';
                            this.showSnack();
                        }
                    } else {
                        this.Msg='error, comunicar a soporte';
                        this.msgbox=true;
                        this.color='success';
                        this.showSnack();
                    }
                } else {
                    this.Msg='Rut ingresado no es valido';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();                    
                }
            } catch (error) {
                console.log(error)
            }
        },
        validaRut(rutCompleto){
            if (!/^[0-9]+[-|‐]{1}[0-9kK]{1}$/.test( rutCompleto ))
			    return false;
		    var tmp 	= rutCompleto.split('-');
		    var digv	= tmp[1]; 
		    var ruti 	= tmp[0];
		    if ( digv == 'K' ) digv = 'k' ;
		    return (this.dv(ruti) == digv );
        },
        dv(T){
            var M=0,S=1;
    		for(;T;T=Math.floor(T/10))
	    		S=(S+T%10*(9-M++%6))%11;
		    return S?S-1:'k';
        },
        async search_canjes(){
            this.loading=true;
            this.myPuntoCanje=[];
            try {
                let ruts=this.validaRut(this.cliente_PuntoCanje);
                if (ruts){
                    //obtener la apikey
                    const res_secret = await axios.get(process.env.VUE_APP_URL2 + '/api/v1/token/app/');
                    const data_secret = res_secret.data;
                    if(data_secret[0].existe=='ok'){
                        const mySecret = data_secret[0].token;
                        //generamos el token de usuario
                        const par_token = {
                            secret: mySecret,
                            user: this.cliente_PuntoCanje
                        };
                        const res_token = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/create/token/', par_token);
                        const data_token = res_token.data;
                        if(data_token.Token!='error'){
                            const apiKey = data_token.Token;
                            //verificamos al usuario
                            const headers = {
                                'Content-Type' : 'application/json',
                                'Authorization' : 'Token ' + apiKey
                            };
                            const par_user = {
                                'user': this.cliente_PuntoCanje
                            }
                            const res_user = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/verify/users/',par_user,{headers});
                            const data_user = res_user.data;
                            if(data_user[0].existe=='ok'){
                                //buscamos sus canjes
                                const params = {
                                    'user': this.cliente_PuntoCanje,
                                    'emisor':  this.rut_emisor 
                                };
                                const res = await axios.post(process.env.VUE_APP_URL2 + '/api/v1/bodeganet/search/canjes/',params,{headers});
                                const datos = res.data;
                                console.log(datos);
                                if(datos[0].existe=='ok'){
                                    datos.forEach(element => {
                                        this.myPuntoCanje.push({
                                            id: element.ID,
                                            fecha: element.fecha,
                                            canje: element.canje,
                                            monto: element.monto,
                                            check: false,
                                        })                                        
                                    });
                                } else {
                                    this.Msg='No existen canjes del rut ingresado';
                                    this.msgbox=true;
                                    this.color='red';
                                    this.showSnack();
                                }                
                            } else {
                                this.Msg='Usuario no esta registrado en PuntoCanje';
                                this.msgbox=true;
                                this.color='red';
                                this.showSnack();
                            }                            
                        }
                    }
                } else {
                    this.Msg='Rut ingresado no es valido';
                    this.msgbox=true;
                    this.color='red';
                    this.showSnack();                
                }
            } catch (error) {
                console.log(error)
            };
            this.loading=false
        },
        ck_canje(item){
            if(item.check==true){
                item.check=false
                this.numero_canje=''
            } else {
                //limpiamos todos los canjes
                this.myPuntoCanje.forEach(element => {
                    element.check=false
                });
                //dejamos el item selsccionado en true
                item.check=true;
                this.numero_canje = item.canje
            }
        },
        async imprimirPDF(){
            if (this.OutID!=0){
                try {
                    let myEmisor;
                    let myCliente;
                    let myDetalle=[];
                    let myTotales;
                    let myReferencia;
                    let myFechas;
                    let myDocumento;
                    let myDescuentos=[];
                    //emisor = datos de la sucursal del usuario actual
                    const data_emisor = await this.search_emisor();
                    if(data_emisor.length!=0){
                        myEmisor = data_emisor;
                    };
                    //cliente
                    if(this.rutExpress!='1-9'){
                        const data_cli = this.clientelista.filter(res => res.entidad == this.entidad);
                        if(data_cli.length!=0){
                            myCliente = {
                                "rut": data_cli.rut,
                                "razon": data_cli.nombre,
                                "giro": data_cli.giro,
                                "direccion": data_cli.direccion,
                                "comuna": data_cli.comuna,
                                "ciudad": data_cli.ciudad,
                                "telefono" : '',
                                "email" : data_cli.email
                            }
                        };
                    } else {
                        myCliente = {
                            "rut": this.rutExpress,
                            "razon": this.clienteExpress,
                            "giro": '',
                            "direccion": '',
                            "comuna": '',
                            "ciudad": '',
                            "telefono" : '',
                            "email" : ''
                        }
                    };
                    //detalle
                    this.items.forEach(element => {
                        myDetalle.push({
                            "sku": element.sku,
                            "producto": element.producto,
                            "precio": element.valor,
                            "cantidad": element.valorCantidad
                        })                        
                    });
                    //totales
                    myTotales = {
                        "neto": this.mto_totalNeto,
                        "impuesto": this.impuesto,
                        "iva": this.mto_totalIva,
                        "total": this.mto_totalVenta,
                    };
                    //referencias
                    myReferencia = {
                        "folio": '',
                        "fecha": '',
                        "tipo": '',
                        "razon": ''
                    };
                    //fechas
                    myFechas = {
                        "emision": this.fechaNacional(this.hoy),
                        "vencimiento": this.fechaNacional(this.vencimiento),
                    };
                    //documento
                    const documento='NOTA DE VENTA';
                    myDocumento = {
                        "folio": this.OutID,
                        "documento": documento,
                        "ted": '',
                        "sucursal": this.txtOffice
                    };
                    //descuentos
                    this.items.forEach(element => {
                        if(parseFloat(element.descuento)!=0){
                            myDescuentos.push({
                                "sku": element.sku,
                                "producto": element.producto,
                                "precio": element.valor,
                                "cantidad": element.valorCantidad,
                                "descuento": element.descuento,
                                "concepto": element.concepto,
                            })
                        }
                    });
                    //verPDF
                    const array_PDF = {
                        "myEmisor" : myEmisor,
                        "myCliente" : myCliente,
                        "myDetalle" : myDetalle,
                        "myTotales" : myTotales,
                        "myReferencia" : myReferencia,
                        "myFechas" : myFechas,
                        "myDocumento" : myDocumento,
                        "myDescuentos": myDescuentos
                    };
                    console.log('parametros PDF', array_PDF)
                    await this.verPDF(array_PDF);
                } catch (error) {
                    console.log(error)
                }
            }
        }

    }
}
</script>